
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7F6VS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1BAHN")).default);
$parcel$export(module.exports, "useNaturalLanguageMode", () => (parcelRequire("5xvWJ")).useNaturalLanguageMode);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $1BAHN = parcelRequire("1BAHN");

var $5xvWJ = parcelRequire("5xvWJ");

});
parcelRegister("1BAHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $24339dc6fcf29cd2$export$2e2bcd8739ae039);

var $cgrPm = parcelRequire("cgrPm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $ifQ0j = parcelRequire("ifQ0j");

var $512eM = parcelRequire("512eM");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");

var $6s1PB = parcelRequire("6s1PB");

var $5xvWJ = parcelRequire("5xvWJ");

var $aVifT = parcelRequire("aVifT");

var $4XmkC = parcelRequire("4XmkC");

var $8ej2m = parcelRequire("8ej2m");

var $dkjuA = parcelRequire("dkjuA");
const $24339dc6fcf29cd2$var$JQLBuilderWithAI = ({ onToggleAi: onToggleAi, fragmentKey: fragmentKey, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
    const data = (0, $8Uumt.useFragment)((0, $cgrPm.default), fragmentKey);
    const isAtlassianIntelligenceEnabled = !!data?.shouldShowAtlassianIntelligence;
    const userPreferencesData = data?.userPreferences || null;
    // when cleaning up getWillShowNav4() remove useState(...) and rename isNLMode to isNaturalLanguageMode
    const [isNaturalLanguageMode, setIsNaturalLanguageMode] = (0, $5uXOq.useState)(false);
    const [isNLMode, { toggleNaturalLanguageMode: toggleNaturalLanguageMode, exitNaturalLanguageMode: exitNaturalLanguageMode }] = (0, $5xvWJ.useNaturalLanguageMode)();
    const jqlDebuggerStoreActions = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $512eM.useJqlDebuggerStoreActions)() : undefined;
    if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) jqlDebuggerStoreActions?.setExitNaturalLanguageMode(exitNaturalLanguageMode);
    const autoFocusNLToggle = (0, $5uXOq.useRef)(false);
    const onToggleNaturalLanguageMode = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $3HwlS.getWillShowNav4)()) {
            onToggleAi && onToggleAi(!isNaturalLanguageMode);
            setIsNaturalLanguageMode(!isNaturalLanguageMode);
            if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) // When the user enters the NL mode, we want to reset the JQL debugger so that two AI experiences are not live simultaneously
            // Current isNaturalLanguageMode is false -> means that onToggleNaturalLanguageMode was called to enter the NaturalLanguage Mode
            {
                if (!isNaturalLanguageMode) jqlDebuggerStoreActions?.resetStatus('ON_ENTER_NL_MODE');
            }
        } else {
            onToggleAi && onToggleAi(!isNLMode);
            toggleNaturalLanguageMode();
            if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) // When the user enters the NL mode, we want to reset the JQL debugger so that two AI experiences are not live simultaneously
            // Current isNLMode is false -> means that onToggleNaturalLanguageMode was called to enter the NaturalLanguage Mode
            {
                if (!isNLMode) jqlDebuggerStoreActions?.resetStatus('ON_ENTER_NL_MODE');
            }
        }
        // Return focus to the toggle button when exiting NL mode
        autoFocusNLToggle.current = true;
    }, [
        isNLMode,
        isNaturalLanguageMode,
        onToggleAi,
        toggleNaturalLanguageMode,
        jqlDebuggerStoreActions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        autoFocusNLToggle.current = false;
    });
    // Delegate to JQLBuilder if NL is not enabled
    if (!isAtlassianIntelligenceEnabled) return (0, $4R6GH.fg)('nin_request_hydrate_query_earlier') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVifT.AIPremiumUpsellButtonPopup), null),
        maybeHydrationQueryReference: maybeHydrationQueryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVifT.AIPremiumUpsellButtonPopup), null)
    });
    const JQLBuilderWithAIComponent = (0, $4R6GH.fg)('nin_request_hydrate_query_earlier') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        maybeHydrationQueryReference: maybeHydrationQueryReference,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ej2m.NaturalLanguageToggle), {
            autoFocus: autoFocusNLToggle.current,
            onClick: onToggleNaturalLanguageMode,
            fragmentRef: data
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ej2m.NaturalLanguageToggle), {
            autoFocus: autoFocusNLToggle.current,
            onClick: onToggleNaturalLanguageMode,
            fragmentRef: data
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jqlBuilderWithAi",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            isAiAvailable: isAtlassianIntelligenceEnabled,
            isAiEnabled: (0, $3HwlS.getWillShowNav4)() ? isNLMode : isNaturalLanguageMode
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkjuA.SpotlightTourContainer), {
        userPreferences: userPreferencesData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $24339dc6fcf29cd2$var$jqlBuilderWrapperStyles
    }, (0, $3HwlS.getWillShowNav4)() && isNLMode || isNaturalLanguageMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XmkC.NaturalLanguageToJQLWrapper), {
        ...props,
        onBack: onToggleNaturalLanguageMode,
        userPreferences: userPreferencesData
    }) : JQLBuilderWithAIComponent)));
};
var $24339dc6fcf29cd2$export$2e2bcd8739ae039 = $24339dc6fcf29cd2$var$JQLBuilderWithAI;
const $24339dc6fcf29cd2$var$jqlBuilderWrapperStyles = (0, $8CUq3.xcss)({
    // JQL editor height is 52px for both "Basic" and "JQL" views
    // This can cause a layout shift when switching to the AI searchbox
    // Prior to using a min height on the common parent, the approach taken to avoid the layout shift is by using a matching margin
    // Using the min-height on the common parent is more immune for future changes in the AI search field effective height
    minHeight: '52px'
});

});
parcelRegister("cgrPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a9568d8491c510$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87faaa1bbe4769cbca56503d4e11c68c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46a9568d8491c510$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "atlassianIntelligenceProductFeature"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI",
        "selections": [
            {
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "feature",
                                "variableName": "atlassianIntelligenceProductFeature"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "atlassianIntelligenceProductFeatureInput"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "shouldShowAtlassianIntelligence"
            },
            {
                "kind": "FragmentSpread",
                "name": "naturalLanguageToggle_jqlBuilderWithAi"
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "spotlightTourContainer_jqlBuilderWithAi"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_jqlBuilder_JQLBuilder"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$46a9568d8491c510$var$node.hash = "ded14f441227ee258bb1f97921cfaf47";
var $46a9568d8491c510$export$2e2bcd8739ae039 = $46a9568d8491c510$var$node;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5xvWJ", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageMode", () => $95fabc3a48223559$export$617c50bbd595c5ac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $95fabc3a48223559$var$initialState = {
    isNaturalLanguageMode: false
};
const $95fabc3a48223559$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        },
    exitNaturalLanguageMode: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
};
const $95fabc3a48223559$var$Store = (0, $iXqE5.createStore)({
    initialState: $95fabc3a48223559$var$initialState,
    actions: $95fabc3a48223559$export$e324594224ef24da
});
const $95fabc3a48223559$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($95fabc3a48223559$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $95fabc3a48223559$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $95fabc3a48223559$export$617c50bbd595c5ac = (0, $3sQ5x.createHook)($95fabc3a48223559$var$Store, {
    selector: $95fabc3a48223559$var$getNaturalLanguageMode
});
const $95fabc3a48223559$export$d99c2d47e59edc60 = (0, $3sQ5x.createActionsHook)($95fabc3a48223559$var$Store);

});

parcelRegister("aVifT", function(module, exports) {

$parcel$export(module.exports, "AIPremiumUpsellButtonPopup", () => $51d719ccabe8dd19$export$8a1c240781b9aa13);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $3ZC89 = parcelRequire("3ZC89");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $jgJNO = parcelRequire("jgJNO");


var $4J0Lr = parcelRequire("4J0Lr");

var $2vSU6 = parcelRequire("2vSU6");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $cwiPX = parcelRequire("cwiPX");

var $koVbs = parcelRequire("koVbs");

var $b3Gth = parcelRequire("b3Gth");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iviep = parcelRequire("iviep");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $xDeUU = parcelRequire("xDeUU");
const $51d719ccabe8dd19$var$DialogContents = ({ onClose: onClose, buttonTrigger: buttonTrigger })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51d719ccabe8dd19$var$backgroundBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $51d719ccabe8dd19$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $51d719ccabe8dd19$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51d719ccabe8dd19$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwiPX.default), {
        alt: formatMessage((0, $xDeUU.default).bannerAltText)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51d719ccabe8dd19$var$closeButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        LEGACY_size: "small",
        label: formatMessage((0, $xDeUU.default).closeModal),
        color: "var(--ds-icon, #44546F)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "start",
        space: "space.100",
        xcss: $51d719ccabe8dd19$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $xDeUU.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $xDeUU.default).descriptionSporkIssueTerminologyRefreshM4 : (0, $xDeUU.default).descriptionSpork, {
        link: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                target: "_blank",
                href: (0, $a56b51abbcbea207$export$af6d68522cb370b8),
                onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atlassianIntelligenceLearnMore')
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        xcss: $51d719ccabe8dd19$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: buttonTrigger,
        onClick: onClose,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: formatMessage((0, $xDeUU.default).premiumIconLabel),
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "medium",
        weight: "medium",
        color: "color.text.inverse"
    }, formatMessage((0, $xDeUU.default).tryItFreeButton)))))));
};
const $51d719ccabe8dd19$var$entryPointParams = {};
const $51d719ccabe8dd19$export$8a1c240781b9aa13 = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isSoftwareAppStandardEdition = (0, $iviep.isStandardEdition)((0, $2vSU6.SOFTWARE_PROJECT), appEditions);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), $51d719ccabe8dd19$var$entryPointParams);
    const tryItFreeButtonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const onAIButtonClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (!isOpen) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'jqlBuilderAiTogglePremiumUpsell');
        setIsOpen((open)=>!open);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onTryItFreeButtonClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'upgradeToPremiumFromJqlAiUpsell');
        setIsOpen(false);
    }, [
        setIsOpen
    ]); // We only want to show the AI Premium Upsell button to Standard Edition Site Admins
    if (!isSiteAdmin || !isSoftwareAppStandardEdition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51d719ccabe8dd19$var$DialogContents, {
                onClose: onTryItFreeButtonClick,
                buttonTrigger: tryItFreeButtonTrigger
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4J0Lr.AIButton), {
                ...triggerProps,
                onClick: onAIButtonClick
            }),
        placement: "bottom-start",
        messageId: "jql-builder-with-ai.ui.ai-premium-upsell-button-popup.popup.ai-premium-upsell-button",
        messageType: "marketing"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};
const $51d719ccabe8dd19$var$backgroundBorderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius.100',
    width: '450px',
    padding: 'space.025',
    position: 'relative',
    background: `linear-gradient(135deg, ${"var(--ds-background-accent-blue-subtle, #579DFF)"}, ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"})`
});
const $51d719ccabe8dd19$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay'
});
const $51d719ccabe8dd19$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'border.radius',
    borderTopRightRadius: 'border.radius'
});
const $51d719ccabe8dd19$var$imageStyles = (0, $8CUq3.xcss)({
    objectFit: 'cover',
    width: '100%',
    borderRadius: '3px 3px 0 0'
});
const $51d719ccabe8dd19$var$closeButtonWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: '0',
    right: '0',
    padding: 'space.200'
});
const $51d719ccabe8dd19$var$contentContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300',
    alignSelf: 'stretch'
});
const $51d719ccabe8dd19$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    marginTop: 'space.100'
});

});
const $a56b51abbcbea207$export$1a33ff8e70228fd6 = 'Atlassian Intelligence';
const $a56b51abbcbea207$export$9c7ce577b80c2668 = 8;
const $a56b51abbcbea207$export$d0d4ed81e1ed42ec = 6;
const $a56b51abbcbea207$export$b6e7a25078ed1a5f = 7;
const $a56b51abbcbea207$export$d0f488901b85b750 = 'LIKE';
const $a56b51abbcbea207$export$7ca6708a8b83d828 = 'DISLIKE';
const $a56b51abbcbea207$export$af6d68522cb370b8 = 'https://support.atlassian.com/organization-administration/docs/get-started-with-atlassian-intelligence/';

parcelRegister("4J0Lr", function(module, exports) {

$parcel$export(module.exports, "AIButton", () => $c292cdb8315149be$export$a51986b9c6d9ac89);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");

var $94cfG = parcelRequire("94cfG");

var $37XBA = parcelRequire("37XBA");
const $c292cdb8315149be$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ autoFocus: autoFocus, onClick: onClick }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        spacing: "none",
        isShadow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        appearance: "subtle",
        onClick: onClick,
        spacing: "none",
        "aria-label": "AI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.050",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37XBA.AiIcon), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.selected",
        weight: "medium"
    }, "AI"))))));

});
parcelRegister("37XBA", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $1a27254ae9bfd82b$export$762da6f7f5ace732);

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
const $1a27254ae9bfd82b$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-text-subtlest, #626F86)";
        textAccentBlueB400 = "var(--ds-text-subtlest, #626F86)";
    } else if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-icon-accent-gray, #758195)";
        textAccentBlueB400 = "var(--ds-text-accent-gray, #44546F)";
    } else {
        iconAccentBlueB200 = "var(--ds-icon-accent-blue, #1D7AFC)";
        textAccentBlueB400 = "var(--ds-text-accent-blue, #0055CC)";
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dV6Te.default), {
        ...props,
        testId: "atlassian-intelligence.common.ui.ai-icon.svg-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});


parcelRegister("cwiPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79298d38d2d69d2$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $5Wm8I = parcelRequire("5Wm8I");

var $l5uiB = parcelRequire("l5uiB");
const $f79298d38d2d69d2$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($l5uiB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5Wm8I))
});
var $f79298d38d2d69d2$export$2e2bcd8739ae039 = $f79298d38d2d69d2$var$Illustration;
// for advanced use only
const $f79298d38d2d69d2$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("5Wm8I", function(module, exports) {
module.exports = new URL("ai-premium-upsell-darkmode.090d0954.svg", import.meta.url).toString();

});

parcelRegister("l5uiB", function(module, exports) {
module.exports = new URL("ai-premium-upsell.b942d6b5.svg", import.meta.url).toString();

});


parcelRegister("iviep", function(module, exports) {

$parcel$export(module.exports, "hasPermissionGate", () => $39a9a56ffba74d2e$export$2d7869ada39bf0b);
$parcel$export(module.exports, "isStandardEdition", () => $39a9a56ffba74d2e$export$4b1af5399a63f452);
$parcel$export(module.exports, "isFreeEdition", () => $39a9a56ffba74d2e$export$a8e9f6df1deeb7d);
$parcel$export(module.exports, "hasPermissionToArchive", () => $39a9a56ffba74d2e$export$70eef98d89c5d158);

var $2vSU6 = parcelRequire("2vSU6");

var $ldyPw = parcelRequire("ldyPw");
const $39a9a56ffba74d2e$export$2d7869ada39bf0b = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.PREMIUM_EDITION);
const $39a9a56ffba74d2e$export$4b1af5399a63f452 = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.STANDARD_EDITION);
const $39a9a56ffba74d2e$export$a8e9f6df1deeb7d = (projectType, appEditions)=>(0, $ldyPw.getEditionForProject)(projectType, appEditions) === (0, $ldyPw.FREE_EDITION);
const $39a9a56ffba74d2e$var$hasPermissionToArchiveProject = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can archive the simplified/next-gen project
    return isAdmin; // Only Jira admins can archive the classic software project
};
const $39a9a56ffba74d2e$export$70eef98d89c5d158 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    switch(projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
        case 0, $2vSU6.CORE_PROJECT:
            return $39a9a56ffba74d2e$var$hasPermissionToArchiveProject(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("xDeUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b888bbbcec1c3bfe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b888bbbcec1c3bfe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeModal: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.close-modal",
        "defaultMessage": "Close modal"
    },
    bannerAltText: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.banner-alt-text",
        "defaultMessage": "Decorative banner"
    },
    premiumIconLabel: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.premium-icon-label",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    heading: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.heading",
        "defaultMessage": "No more complex queries"
    },
    descriptionSpork: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork",
        "defaultMessage": "Search for issues in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium."
    },
    tryItFreeButton: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.try-it-free-button",
        "defaultMessage": "Try it free"
    },
    descriptionSporkIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium."
    }
});

});


parcelRegister("4XmkC", function(module, exports) {

$parcel$export(module.exports, "NaturalLanguageToJQLWrapper", () => $ba13e3e09d02b915$export$b04216da143ef4b0);

var $hAInk = parcelRequire("hAInk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $761Hb = parcelRequire("761Hb");

var $8QPci = parcelRequire("8QPci");

var $qLuSt = parcelRequire("qLuSt");

var $2jDmD = parcelRequire("2jDmD");

var $032ey = parcelRequire("032ey");


var $icajz = parcelRequire("icajz");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $512eM = parcelRequire("512eM");

var $6s1PB = parcelRequire("6s1PB");

var $5Ys8c = parcelRequire("5Ys8c");

var $inRfC = parcelRequire("inRfC");

var $ekmxu = parcelRequire("ekmxu");

var $bj2da = parcelRequire("bj2da");

var $79sYG = parcelRequire("79sYG");
const $ba13e3e09d02b915$var$createUseDebouncedEventForAIResult = ()=>{
    const lastEventPublishedState = {};
    let previousTimeoutId = setTimeout(()=>({}), 0); // Current debounce timeout is 2 seconds. This value was chosen by observation only. Feel free to update as necessary
    const DEBOUNCE_TIMEOUT = 2000; // To avoid any memory leaks, we clear the lastPublished entry after 10seconds
    // The idea here is that events can duplicated if multiple events for same promptId arrive 10seconds apart
    // In practice however, all events finish arriving within 500ms-1500ms
    const DUPLICATE_CHECK_CLEAR_TIMEOUT = 10000;
    return function useDebouncedReadyEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
        const fireEventForAIResult = (0, $5uXOq.useCallback)(({ isSuccess: isSuccess, is5xxError: is5xxError, promptId: promptId = '', errorOrigin: errorOrigin = '' })=>{
            // Clear any pending timeouts so that the latest event data is used
            // If the promptId is different, then we don't need to clear the timeout, and just let the event go through
            if (lastEventPublishedState[promptId] === 'PENDING') clearTimeout(previousTimeoutId);
            if (lastEventPublishedState[promptId] === 'PUBLISHED') // Event already published. Ignore the latest data and stick with the previously published event
            return;
             // Mark that an event is pending for the particular promptId
            lastEventPublishedState[promptId] = 'PENDING'; // Update the timeoutId, so that it can be cleared when the data becomes stale (with a newer event)
            previousTimeoutId = setTimeout(()=>{
                if (isSuccess) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                    aiFeatureName: (0, $f88d26c36cb85dbd$export$819aee5dd7b4244d),
                    singleInstrumentationID: promptId,
                    userGeneratedAI: 1,
                    proactiveAIGenerated: 0,
                    isAIFeature: 1
                });
                else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
                    aiFeatureName: (0, $f88d26c36cb85dbd$export$819aee5dd7b4244d),
                    singleInstrumentationID: promptId,
                    errorOrigin: errorOrigin,
                    userGeneratedAI: 1,
                    proactiveAIGenerated: 0,
                    isAIFeature: 1,
                    is5xxError: is5xxError
                });
                 // Mark the events corresponding to the latest promptId as published
                // So that any events that arrive after the debounce timeout are ignored
                // This is because having a unique `aiResult viewed` event is more important than having stale data (searchMode) in the event
                lastEventPublishedState[promptId] = 'PUBLISHED'; // Clear lastEventPublished entry to avoid memory leaks
                setTimeout(()=>{
                    delete lastEventPublishedState[promptId];
                }, DUPLICATE_CHECK_CLEAR_TIMEOUT);
            }, DEBOUNCE_TIMEOUT);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEventForAIResult: fireEventForAIResult
        };
    };
};
const $ba13e3e09d02b915$var$useDebouncedReadyEventForAIResult = $ba13e3e09d02b915$var$createUseDebouncedEventForAIResult();
const $ba13e3e09d02b915$export$b04216da143ef4b0 = ({ onBack: onBack, userPreferences: userPreferences, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [jqlTooComplex, setJqlTooComplex] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { onSearch: onSearch } = props;
    const onPromptSuccess = (0, $5uXOq.useCallback)((generatedJql)=>{
        onSearch && onSearch(generatedJql);
        setJqlTooComplex(false);
    }, [
        onSearch
    ]);
    const { onJourneyStart: onJourneyStart } = props;
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'aiInlinePrompt', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const placeholders = (0, $inRfC.usePlaceholders)();
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $hAInk.default), userPreferences);
    const { onEndAITour: onEndAITour } = (0, $5Ys8c.useAITourActions)();
    const [isTourActive] = (0, $8QPci.useIsActiveSpotlightCard)([
        (0, $761Hb.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL,
        (0, $761Hb.cardKeys).JQL_BUILDER_NL_TO_JQL
    ]);
    const handleSearchModeChange = (searchMode, reason)=>{
        setJqlTooComplex(searchMode === (0, $032ey.SEARCH_MODE_ADVANCED) && reason === 'QueryUnsupported');
    };
    const renderSpotlightCard = ({ onSetActiveCard: onSetActiveCard, onEndTour: onEndTour })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qLuSt.default), {
            cardKey: (0, $761Hb.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL,
            actions: [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $761Hb.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER);
                    },
                    text: formatMessage((0, $79sYG.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: formatMessage((0, $79sYG.default).skip)
                }
            ],
            heading: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $79sYG.default).globalTourHeadingIssueTerminologyRefreshM4 : (0, $79sYG.default).globalTourHeading),
            target: "jql-builder-with-ai.natural-language-to-jql",
            targetRadius: 8,
            targetBgColor: "var(--ds-background-input, #FFFFFF)",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight",
            messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight-tour-card.jql-builder-with-ai.natural-language-to-jql.spotlight.1",
            messageType: "transactional"
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $79sYG.default).globalTourBodyIssueTerminologyRefreshM4 : (0, $79sYG.default).globalTourBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qLuSt.default), {
            cardKey: (0, $761Hb.cardKeys).JQL_BUILDER_NL_TO_JQL,
            actions: [
                {
                    onClick: ()=>{
                        // End the tour in AI tour store
                        onEndAITour(); // End the tour in NIN changeboarding store
                        onEndTour();
                    },
                    text: formatMessage((0, $79sYG.default).done)
                }
            ],
            heading: formatMessage((0, $79sYG.default).tourHeading),
            target: "jql-builder-with-ai.natural-language-to-jql",
            targetRadius: 8,
            targetBgColor: "var(--ds-background-input, #FFFFFF)",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight",
            messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight-tour-card.jql-builder-with-ai.natural-language-to-jql.spotlight.2",
            messageType: "transactional"
        }, formatMessage((0, $79sYG.default).tourBody)));
    (0, $5uXOq.useEffect)(()=>{
        setJqlTooComplex(false);
    }, [
        props.query
    ]);
    const { fireEventForAIResult: fireEventForAIResult } = $ba13e3e09d02b915$var$useDebouncedReadyEventForAIResult();
    const onNLEvent = (0, $5uXOq.useCallback)(({ promptId: promptId, nlResponseType: nlResponseType, is5xxError: is5xxError })=>{
        const jqlErrors = props.jqlMessages?.filter((message)=>message.type === 'error') || [];
        fireEventForAIResult({
            isSuccess: nlResponseType === 'success' && !jqlErrors.length,
            is5xxError: is5xxError,
            promptId: promptId,
            errorOrigin: // eslint-disable-next-line no-nested-ternary
            nlResponseType === 'error' ? 'NL Search Backend' : /* When the nlResponseType is success, it means the NL-to-JQL operation was successful
      However, when props.jqlMessages?.length is not 0, that means there was an error with the jql generated
      Hence it can be marked that the error is coming from NIN
       */ nlResponseType === 'success' && !!jqlErrors.length ? 'NIN' : 'N/A'
        });
    }, [
        fireEventForAIResult,
        props.jqlMessages
    ]);
    const jqlDebuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)(); /**
                                                                 * When the NaturalLanguageToJQLWrapper component unmounts, we want to reset the issue navigator search mode in JQL debugger
                                                                 * This component is mounted when the user is in Natural Language Mode
                                                                 * Currently we use the issueNavigatorSearchMode to enable/disable the JQL debugger proactive experience
                                                                 */ 
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.setIssueNavigatorSearchMode(undefined);
        };
    }, [
        jqlDebuggerStoreActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jDmD.default), {
        name: "jql-builder-with-ai.natural-language-to-jql",
        renderSpotlightCard: renderSpotlightCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $icajz.default), {
        autoFocus: true,
        backButtonLabel: formatMessage((0, $79sYG.default).backButtonLabel),
        onPromptSuccess: onPromptSuccess,
        onBack: onBack,
        onFocus: onJourneyStart ? onFocus : undefined,
        placeholder: isTourActive ? placeholders[0] : placeholders,
        onNLEvent: onNLEvent
    }, (generatedJql)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bj2da.default), {
            ...props,
            userPreferences: userPreferencesData ?? null,
            generatedJql: generatedJql,
            onUpdateSearchMode: handleSearchModeChange,
            key: generatedJql
        }), jqlTooComplex && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekmxu.AlertMessage), {
            appearance: "info",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.jql-too-complex"
        }, formatMessage((0, $79sYG.default).jqlTooComplex)))));
};

});
parcelRegister("hAInk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6614003721c63ff7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0688f7e431ddc63994db6a71faf7973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6614003721c63ff7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilderEmbedded_jqlBuilderWithAi"
        }
    ],
    "type": "JiraUserPreferences"
};
$6614003721c63ff7$var$node.hash = "7bd16e68fc1878ae6b8f7e375bf28056";
var $6614003721c63ff7$export$2e2bcd8739ae039 = $6614003721c63ff7$var$node;

});

const $f88d26c36cb85dbd$export$b8b9d90f9e5bd72b = 'jiraNaturalLanguageToJQL';
const $f88d26c36cb85dbd$export$d57b6b390e78d90f = 'gravity-ai';
const $f88d26c36cb85dbd$export$819aee5dd7b4244d = 'NL Search in Jira';

parcelRegister("icajz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2228747b6de1da38$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dvlgw = parcelRequire("dvlgw");

var $cF3LQ = parcelRequire("cF3LQ");
function $2228747b6de1da38$export$2e2bcd8739ae039({ children: children, ...props }) {
    const onPrompt = (0, $cF3LQ.useNaturalLanguageToJql)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvlgw.default), {
        ...props,
        onPrompt: onPrompt
    }, children);
}

});
parcelRegister("dvlgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $aafba627fcf7570b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $94cfG = parcelRequire("94cfG");

var $9W5pI = parcelRequire("9W5pI");

var $aWHOr = parcelRequire("aWHOr");

var $lb0KO = parcelRequire("lb0KO");

function $aafba627fcf7570b$var$AIInlinePrompt({ autoFocus: autoFocus, backButtonLabel: backButtonLabel, children: children, onBack: onBack, onFocus: onFocus, placeholder: placeholder, ...props }) {
    const [isLoading] = (0, $9W5pI.usePromptIsLoading)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        shouldFitContainer: true,
        spacing: "none",
        isLoading: isLoading,
        testId: "atlassian-intelligence.ui.ai-inline-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0KO.SearchField), {
        autoFocus: autoFocus,
        backButtonLabel: backButtonLabel,
        onBack: onBack,
        onFocus: onFocus,
        placeholder: placeholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWHOr.PromptResponse), props, children));
}
function $aafba627fcf7570b$var$AIInlinePromptWithContainer({ children: children, onPrompt: onPrompt, onPromptSuccess: onPromptSuccess, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9W5pI.PromptContainer), {
        onPrompt: onPrompt,
        onPromptSuccess: onPromptSuccess
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aafba627fcf7570b$var$AIInlinePrompt, props, children));
}
var $aafba627fcf7570b$export$2e2bcd8739ae039 = $aafba627fcf7570b$var$AIInlinePromptWithContainer;

});
parcelRegister("9W5pI", function(module, exports) {

$parcel$export(module.exports, "PromptContainer", () => $aa48732e99b6cc1b$export$f996e810bab47dad);
$parcel$export(module.exports, "usePromptActions", () => $aa48732e99b6cc1b$export$b69cbf7f2fd4c7ba);
$parcel$export(module.exports, "useResponseFeedbackContext", () => $aa48732e99b6cc1b$export$7737761958d6bb6c);
$parcel$export(module.exports, "usePromptResponse", () => $aa48732e99b6cc1b$export$775e0e2ce513f8e7);
$parcel$export(module.exports, "usePrompt", () => $aa48732e99b6cc1b$export$fc7731b33eb53a93);
$parcel$export(module.exports, "useSubmittedPrompt", () => $aa48732e99b6cc1b$export$80b178470b13c8ae);
$parcel$export(module.exports, "usePromptIsLoading", () => $aa48732e99b6cc1b$export$912d74d2ad112159);
$parcel$export(module.exports, "usePromptIsSubmitted", () => $aa48732e99b6cc1b$export$20b39be031988e7a);
$parcel$export(module.exports, "usePromptId", () => $aa48732e99b6cc1b$export$19f80ca0c5d6d88d);
$parcel$export(module.exports, "useScopedId", () => $aa48732e99b6cc1b$export$1f910160e5ac22b);

var $7Jxgt = parcelRequire("7Jxgt");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $j9v3t = parcelRequire("j9v3t");
const $aa48732e99b6cc1b$var$initialState = {
    idPrefix: '',
    isLoading: false,
    isSubmitted: false,
    prompt: '',
    response: undefined,
    submittedPrompt: '',
    cancellable: undefined,
    promptId: ''
};
const $aa48732e99b6cc1b$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $aa48732e99b6cc1b$var$initialState,
    actions: $j9v3t.actions
});
const $aa48732e99b6cc1b$export$f996e810bab47dad = (0, $gg7kZ.createContainer)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                idPrefix: (0, $7Jxgt.v4)()
            });
        }
});
const $aa48732e99b6cc1b$export$b69cbf7f2fd4c7ba = (0, $3sQ5x.createActionsHook)($aa48732e99b6cc1b$export$390f32400eaf98c9);
const $aa48732e99b6cc1b$export$7737761958d6bb6c = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.response?.additionalFeedbackContext
});
const $aa48732e99b6cc1b$var$usePromptResponseGeneric = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.response
});
function $aa48732e99b6cc1b$export$775e0e2ce513f8e7() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $aa48732e99b6cc1b$var$usePromptResponseGeneric();
}
const $aa48732e99b6cc1b$export$fc7731b33eb53a93 = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.prompt
});
const $aa48732e99b6cc1b$export$80b178470b13c8ae = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.submittedPrompt
});
const $aa48732e99b6cc1b$export$912d74d2ad112159 = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.isLoading
});
const $aa48732e99b6cc1b$export$20b39be031988e7a = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.isSubmitted
});
const $aa48732e99b6cc1b$export$19f80ca0c5d6d88d = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: (state)=>state.promptId
});
const $aa48732e99b6cc1b$var$getScopedId = (state, idSuffix)=>`${state.idPrefix}_${idSuffix}`;
const $aa48732e99b6cc1b$export$1f910160e5ac22b = (0, $3sQ5x.createHook)($aa48732e99b6cc1b$export$390f32400eaf98c9, {
    selector: $aa48732e99b6cc1b$var$getScopedId
});

});
parcelRegister("j9v3t", function(module, exports) {

$parcel$export(module.exports, "actions", () => $34523c361bb042eb$export$e324594224ef24da);

var $7Jxgt = parcelRequire("7Jxgt");
function $34523c361bb042eb$var$onHandlePrompt(nextPrompt, promptId) {
    return async (_, { onPrompt: onPrompt })=>{
        try {
            return await onPrompt(nextPrompt, promptId);
        } catch (e) {
            // Ignore errors as this is expected to be handled in the consumer
            return undefined;
        }
    };
}
const $34523c361bb042eb$export$e324594224ef24da = {
    onUpdate (prompt) {
        return ({ setState: setState })=>{
            // Update input prompt
            setState({
                prompt: prompt
            });
        };
    },
    onSubmit (nextPrompt) {
        const nextPromptId = (0, $7Jxgt.v4)();
        return async ({ getState: getState, setState: setState, dispatch: dispatch }, { onPromptSuccess: onPromptSuccess })=>{
            // Set loading state
            setState({
                isLoading: true,
                isSubmitted: true,
                submittedPrompt: nextPrompt,
                promptId: nextPromptId
            });
            const { cancellable: cancellable } = getState();
            // Cancel any in-flight requests
            if (cancellable) cancellable();
            const cancellablePromise = new Promise((resolve, reject)=>{
                // Allow this request to be cancelled
                setState({
                    cancellable: reject
                });
            });
            try {
                const nextResponse = await Promise.race([
                    dispatch($34523c361bb042eb$var$onHandlePrompt(nextPrompt, nextPromptId)),
                    cancellablePromise
                ]);
                nextResponse?.type === 'success' && onPromptSuccess && onPromptSuccess(nextResponse.payload);
                // Set successful response into state
                setState({
                    isLoading: false,
                    response: nextResponse
                });
            } catch (e) {
            // Pending promise was cancelled
            }
        };
    }
};

});


parcelRegister("aWHOr", function(module, exports) {

$parcel$export(module.exports, "PromptResponse", () => $3b533b5a1c039bf1$export$b0c2912e422f4828);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $dBDfp = parcelRequire("dBDfp");

var $9W5pI = parcelRequire("9W5pI");
function $3b533b5a1c039bf1$export$b0c2912e422f4828({ children: children, onNLEvent: onNLEvent }) {
    const [response] = (0, $9W5pI.usePromptResponse)();
    const [isLoading] = (0, $9W5pI.usePromptIsLoading)();
    const [searchFieldId] = (0, $9W5pI.useScopedId)('ai-search-field');
    const [promptId] = (0, $9W5pI.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (response?.type && response?.is5xxError !== undefined && promptId) onNLEvent({
            promptId: promptId,
            nlResponseType: response.type,
            is5xxError: response.is5xxError
        });
    }, [
        createAnalyticsEvent,
        promptId,
        response?.type,
        response?.is5xxError,
        onNLEvent
    ]);
    if (response === undefined) return null;
    switch(response.type){
        case 'success':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b533b5a1c039bf1$var$ResponseContainer, null, children(response.payload, promptId));
        case 'warning':
            // Hide warning message while request is in-flight
            return isLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b533b5a1c039bf1$var$ResponseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dBDfp.HelperMessage), {
                appearance: "warning",
                describedBy: searchFieldId,
                testId: "atlassian-intelligence.ui.prompt-response.warning"
            }, response.payload));
        case 'error':
            // Hide error message while request is in-flight
            return isLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b533b5a1c039bf1$var$ResponseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dBDfp.HelperMessage), {
                appearance: "error",
                describedBy: searchFieldId,
                testId: "atlassian-intelligence.ui.prompt-response.error"
            }, response.payload));
        default:
            return null;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b533b5a1c039bf1$var$ResponseContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxutpp _otyru2gc _18u0utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dBDfp", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $a3132d4a9c5c3cbd$export$8fbe3c7d0ed2c683);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $bU3PY = parcelRequire("bU3PY");
const $a3132d4a9c5c3cbd$export$8fbe3c7d0ed2c683 = ({ appearance: appearance, children: children, describedBy: describedBy, testId: testId })=>{
    const Icon = appearance === 'error' ? (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))) : (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3132d4a9c5c3cbd$var$Message, {
        appearance: appearance,
        role: "alert",
        "aria-describedby": describedBy,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3132d4a9c5c3cbd$var$MessageContent, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3132d4a9c5c3cbd$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _19pku2gc _vwz41tcg",
            __cmplp.appearance === 'error' ? "_syaz1tmw" : "_syazwx40",
            __cmplp.className
        ])
    });
});
const $a3132d4a9c5c3cbd$var$MessageContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lb0KO", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $123d45d6db328c32$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kY99m = parcelRequire("kY99m");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $37XBA = parcelRequire("37XBA");

var $9W5pI = parcelRequire("9W5pI");

var $aqMVy = parcelRequire("aqMVy");

var $5QBLb = parcelRequire("5QBLb");

var $1DEZJ = parcelRequire("1DEZJ");
const $123d45d6db328c32$var$buttonClicked = {
    action: 'clicked',
    actionSubject: 'button'
};
const $123d45d6db328c32$export$b94867ecbd698f21 = ({ autoFocus: autoFocus, backButtonLabel: backButtonLabel, placeholder: placeholder, onBack: onBack, onFocus: onFocus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [searchFieldId] = (0, $9W5pI.useScopedId)('ai-search-field');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [prompt] = (0, $9W5pI.usePrompt)();
    const [isLoading] = (0, $9W5pI.usePromptIsLoading)();
    const [isSubmitted] = (0, $9W5pI.usePromptIsSubmitted)();
    const { onUpdate: onUpdate, onSubmit: onSubmit } = (0, $9W5pI.usePromptActions)();
    const isEmpty = prompt.trim().length === 0;
    const handleSubmit = (0, $5uXOq.useCallback)((e, analyticsEvent, ...attributes)=>{
        if (isEmpty) return;
        onSubmit(prompt);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'aiInlinePromptSubmit', ...attributes);
    }, [
        isEmpty,
        onSubmit,
        prompt
    ]);
    const handleBack = (0, $5uXOq.useCallback)((e, analyticsEvent, ...attributes)=>{
        if (!onBack) return;
        onBack();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'aiInlinePromptBack', ...attributes);
    }, [
        onBack
    ]);
    const handleEnter = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent($123d45d6db328c32$var$buttonClicked);
        handleSubmit(e, analyticsEvent, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        handleSubmit
    ]);
    const handleEscape = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent($123d45d6db328c32$var$buttonClicked);
        handleBack(e, analyticsEvent, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        handleBack
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape') handleEscape(event);
        if (event.key === 'Enter') handleEnter(event);
    }, [
        handleEnter,
        handleEscape
    ]);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        const nextValue = event.currentTarget.value;
        onUpdate(nextValue);
    }, [
        onUpdate
    ]);
    const placeholderToRender = (0, $aqMVy.useAnimatedPlaceholder)(placeholder, prompt.length === 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($123d45d6db328c32$var$TextfieldContainer, {
        isSubmitted: isSubmitted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        id: searchFieldId,
        autoFocus: autoFocus,
        defaultValue: prompt,
        onKeyDown: handleKeyDown,
        onChange: handleChange,
        onFocus: onFocus,
        placeholder: placeholderToRender,
        appearance: "none",
        isCompact: false,
        maxLength: (0, $4R6GH.fg)('ai_search_character_limit_increase_to_1200') ? 1200 : 300,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37XBA.AiIcon), {
            label: (0, $a56b51abbcbea207$export$1a33ff8e70228fd6),
            size: "small"
        }),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QBLb.ShortcutButtons), {
            backButtonLabel: backButtonLabel,
            isLoading: isLoading,
            isSubmitDisabled: isEmpty,
            onSubmit: handleSubmit,
            onBack: onBack ? handleBack : undefined
        }),
        "aria-label": (0, $4R6GH.fg)('gravityai-211-nl-searchfield-aria-label') ? formatMessage((0, $1DEZJ.messages).enterQueryAriaLabel) : undefined
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $123d45d6db328c32$var$TextfieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubmitted: isSubmitted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_195gutpp _1mouu2gc _15h815ya _mtcs15ya _xxgkidpf _yg9midpf _k1ufidpf _zzkzidpf _1r9i1ejb _1a0d1ejb _j1xiidpf _1gtmu2gc",
            __cmplp.isSubmitted && "_1f6didpf _1hzeidpf _9de9idpf _1u7cidpf _1r3midpf _j7rp15vq _1ltf15vq _15dgt94y _7m33t94y _1qjqstnw _1weu7mnp _123y1q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aqMVy", function(module, exports) {

$parcel$export(module.exports, "useAnimatedPlaceholder", () => $8b3d3ca03456b5df$export$9226afce7feb8c4b);

var $5uXOq = parcelRequire("5uXOq");

const $8b3d3ca03456b5df$export$9226afce7feb8c4b = (placeholder, isVisible)=>{
    const defaultPlaceholder = Array.isArray(placeholder) ? placeholder[0] : placeholder;
    const [state, setState] = (0, $5uXOq.useState)({
        placeholderIndex: 0,
        ticksInCurrentPlaceholder: 0,
        visiblePlaceholder: defaultPlaceholder
    });
    const interval = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        // If any of the hook dependencies (placeholder visibility or project key) changes:
        // - Clear any previously created intervals
        // - Reset state back to initial
        clearInterval(interval.current);
        setState({
            placeholderIndex: 0,
            ticksInCurrentPlaceholder: 0,
            visiblePlaceholder: defaultPlaceholder
        });
        // Only animate when a series of placeholders are provided
        if (isVisible && Array.isArray(placeholder) && placeholder.length > 1) interval.current = setInterval(()=>{
            setState(({ placeholderIndex: placeholderIndex, ticksInCurrentPlaceholder: ticksInCurrentPlaceholder, visiblePlaceholder: visiblePlaceholder })=>{
                const targetPlaceholder = placeholder[placeholderIndex];
                if (visiblePlaceholder !== targetPlaceholder) return {
                    placeholderIndex: placeholderIndex,
                    ticksInCurrentPlaceholder: 0,
                    visiblePlaceholder: targetPlaceholder.slice(0, visiblePlaceholder.length + 1)
                };
                if (ticksInCurrentPlaceholder === (0, $8881d5f8aeacdc55$export$411bcf646d391199)) return {
                    placeholderIndex: placeholderIndex < placeholder.length - 1 ? placeholderIndex + 1 : 0,
                    ticksInCurrentPlaceholder: 0,
                    visiblePlaceholder: ''
                };
                return {
                    placeholderIndex: placeholderIndex,
                    ticksInCurrentPlaceholder: ticksInCurrentPlaceholder + 1,
                    visiblePlaceholder: visiblePlaceholder
                };
            });
        }, (0, $8881d5f8aeacdc55$export$47272beff44c3250));
        return ()=>clearInterval(interval.current);
    }, [
        defaultPlaceholder,
        isVisible,
        placeholder
    ]);
    return state.visiblePlaceholder;
};

});
/**
 * Duration of each placeholder animation tick (i.e. time it takes to type 1 character)
 */ const $8881d5f8aeacdc55$export$47272beff44c3250 = 60;
const $8881d5f8aeacdc55$export$411bcf646d391199 = 30;


parcelRegister("5QBLb", function(module, exports) {

$parcel$export(module.exports, "ShortcutButtons", () => $15c6002533b4b3f7$export$1580d8f0e94a7ac7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $3ctui = parcelRequire("3ctui");
const $15c6002533b4b3f7$var$goButtonSelectorName = 'atlassian-intelligence.ui.search-field.shortcut-buttons.go-button';
const $15c6002533b4b3f7$export$373f05fe8d26f4ab = `[data-component-selector="${$15c6002533b4b3f7$var$goButtonSelectorName}"]`;
const $15c6002533b4b3f7$var$goButtonContentWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    gap: 'space.050'
});
const $15c6002533b4b3f7$export$1580d8f0e94a7ac7 = ({ backButtonLabel: backButtonLabel, isLoading: isLoading, isSubmitDisabled: isSubmitDisabled, onSubmit: onSubmit, onBack: onBack })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15c6002533b4b3f7$var$GoButton, {
        spacing: "none",
        appearance: "primary",
        isDisabled: isSubmitDisabled,
        onClick: onSubmit,
        testId: "atlassian-intelligence.ui.search-field.shortcut-buttons.go-button",
        "data-component-selector": $15c6002533b4b3f7$var$goButtonSelectorName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        paddingInline: "space.300",
        xcss: $15c6002533b4b3f7$var$goButtonContentWrapperStyles
    }, formatMessage((0, $3ctui.default).go), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "inherit"
    }, "\u23CE"))), onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15c6002533b4b3f7$var$BackButton, {
        appearance: "subtle",
        spacing: "none",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: backButtonLabel ?? formatMessage((0, $3ctui.default).back)
        }),
        onClick: onBack,
        testId: "atlassian-intelligence.ui.search-field.shortcut-buttons.back-button"
    }));
};
const $15c6002533b4b3f7$var$buttonStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $15c6002533b4b3f7$var$GoButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o _4t3i1wug _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $15c6002533b4b3f7$var$BackButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o _4t3i1wug _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ctui", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af799c3bf82bfe8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3af799c3bf82bfe8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    go: {
        "id": "atlassian-intelligence.search-field.shortcut-buttons.go",
        "defaultMessage": "Go"
    },
    back: {
        "id": "atlassian-intelligence.search-field.shortcut-buttons.back",
        "defaultMessage": "Back - Exit Atlassian Intelligence"
    }
});

});


parcelRegister("1DEZJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a4b5a12186c1123c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a4b5a12186c1123c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    enterQueryAriaLabel: {
        "id": "atlassian-intelligence.search-field.enter-query-aria-label",
        "defaultMessage": "Enter your natural language query, for example:"
    }
});

});



parcelRegister("cF3LQ", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageToJql", () => $9812f35ed6e344c4$export$91f40a372bbf523a);

var $iZj3c = parcelRequire("iZj3c");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $koeKL = parcelRequire("koeKL");


var $8bu76 = parcelRequire("8bu76");

var $hQRtt = parcelRequire("hQRtt");

var $10A71 = parcelRequire("10A71");
const $9812f35ed6e344c4$var$RATE_LIMIT_SUPPORT_LINK = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $9812f35ed6e344c4$var$SERVER_ERROR_SUPPORT_LINK = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $9812f35ed6e344c4$var$fireNLErrorAnalytics = (errorType, error)=>{
    (0, $jcw0u.default)({
        attributes: {
            errorType: errorType
        },
        meta: {
            id: 'useNaturalLanguageToJqlQuery',
            packageName: (0, $f88d26c36cb85dbd$export$b8b9d90f9e5bd72b),
            teamName: (0, $f88d26c36cb85dbd$export$d57b6b390e78d90f)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $9812f35ed6e344c4$export$91f40a372bbf523a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectContext = (0, $dAfqg.useProjectContext)();
    const projectKey = (0, $4R6GH.fg)('jira_nl2jql_forward_proejct_context') ? projectContext.data?.projectKey || null : null;
    return (0, $5uXOq.useCallback)(async (prompt, promptId)=>{
        /**
     * The attributes populated for centralised AI MAU calculation is mentioned here:
     * https://hello.atlassian.net/wiki/spaces/AAI/pages/3115805726/Single+Instrumentation+for+AI+MAU
     * Note: the 1 in userGeneratedAI represents a 'boolean' sort of value
     */ (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
            aiFeatureName: (0, $f88d26c36cb85dbd$export$819aee5dd7b4244d),
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            singleInstrumentationID: promptId,
            isAIFeature: 1
        });
        return (0, $8Uumt.fetchQuery)(environment, (0, $iZj3c.default), {
            cloudId: cloudId,
            naturalLanguageInput: prompt,
            iteration: 'ITERATION_2',
            project: projectKey
        }).toPromise().then((data)=>{
            if (data) {
                const { jira: { naturalLanguageToJql: { generatedJQL: generatedJQL, generatedJQLError: generatedJQLError } } } = data;
                if (generatedJQL != null) {
                    const additionalFeedbackContext = [
                        {
                            id: 'JQL Response',
                            value: generatedJQL
                        }
                    ];
                    return {
                        type: 'success',
                        is5xxError: false,
                        payload: generatedJQL,
                        additionalFeedbackContext: additionalFeedbackContext
                    };
                }
                // If we have no JQL or relevant errors then show a warning message
                if (generatedJQLError == null) {
                    // TODO - revise error type: JNLIS-488
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('failed_response');
                    return {
                        type: 'warning',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bu76.MessageWithFeedbackButton), {
                            message: formatMessage((0, $10A71.default).noJqlReturned),
                            linkText: formatMessage((0, $10A71.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraGeneratedJqlInvalidError') {
                    // TODO - revise error type: JNLIS-488
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bu76.MessageWithFeedbackButton), {
                            message: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $10A71.default).invalidJqlErrorNonFinalIssueTerminologyRefreshM4 : (0, $10A71.default).invalidJqlErrorNonFinal),
                            linkText: formatMessage((0, $10A71.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUnsupportedLanguageError') {
                    // TODO - revise error type: JNLIS-488
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bu76.MessageWithFeedbackButton), {
                            message: formatMessage((0, $10A71.default).unsupportedLanguageErrorNonFinal),
                            linkText: formatMessage((0, $10A71.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUsageLimitExceededError') {
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('rate_limit_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQRtt.MessageWithSupportLink), {
                            message: (0, $10A71.default).errorRateLimit,
                            href: $9812f35ed6e344c4$var$RATE_LIMIT_SUPPORT_LINK
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUIExposedError' && generatedJQLError?.message != null) {
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bu76.MessageWithFeedbackButton), {
                            message: generatedJQLError.message,
                            linkText: formatMessage((0, $10A71.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraServerError') {
                    $9812f35ed6e344c4$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: true,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQRtt.MessageWithSupportLink), {
                            message: (0, $10A71.default).serverError,
                            href: $9812f35ed6e344c4$var$SERVER_ERROR_SUPPORT_LINK
                        })
                    };
                }
            }
            // TODO - revise error type: JNLIS-488
            $9812f35ed6e344c4$var$fireNLErrorAnalytics('server_error');
            return {
                type: 'error',
                is5xxError: true,
                payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQRtt.MessageWithSupportLink), {
                    message: (0, $10A71.default).serverError,
                    href: $9812f35ed6e344c4$var$SERVER_ERROR_SUPPORT_LINK
                })
            };
        }).catch((error)=>{
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 429) {
                $9812f35ed6e344c4$var$fireNLErrorAnalytics('rate_limit_error', error);
                return {
                    type: 'error',
                    is5xxError: false,
                    payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQRtt.MessageWithSupportLink), {
                        message: (0, $10A71.default).errorRateLimit,
                        href: $9812f35ed6e344c4$var$RATE_LIMIT_SUPPORT_LINK
                    })
                };
            }
            // TODO - revise error type: JNLIS-488
            $9812f35ed6e344c4$var$fireNLErrorAnalytics('graphql_error', error);
            return {
                type: 'error',
                is5xxError: true,
                payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQRtt.MessageWithSupportLink), {
                    message: (0, $10A71.default).serverError,
                    href: $9812f35ed6e344c4$var$SERVER_ERROR_SUPPORT_LINK
                })
            };
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        environment,
        formatMessage,
        projectKey
    ]);
};

});
parcelRegister("iZj3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a7e98f83de79a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbc11c79a2fa7e03580e6f6e88e95914>>
 * @relayHash 42c1f0f238e4ad92d4e813a2f1345025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b
const $29a7e98f83de79a8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "iteration"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "naturalLanguageInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "project"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "iteration",
                    "variableName": "iteration"
                },
                {
                    "kind": "Variable",
                    "name": "naturalLanguageInput",
                    "variableName": "naturalLanguageInput"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "project"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "searchContext"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "generatedJQL"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNaturalLanguageToJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraJQLFromNaturalLanguage",
                                    "kind": "LinkedField",
                                    "name": "naturalLanguageToJql",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "generatedJQLError",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraUIExposedError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraUsageLimitExceededError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraGeneratedJqlInvalidError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraUnsupportedLanguageError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.naturalLanguageToJql"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNaturalLanguageToJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJQLFromNaturalLanguage",
                            "kind": "LinkedField",
                            "name": "naturalLanguageToJql",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "generatedJQLError",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ 
                                            ],
                                            "type": "JiraUIExposedError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b",
            "metadata": {},
            "name": "useNaturalLanguageToJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$29a7e98f83de79a8$var$node.hash = "fc551bf7230ae7a4cf420565001ddefc";
var $29a7e98f83de79a8$export$2e2bcd8739ae039 = $29a7e98f83de79a8$var$node;

});

parcelRegister("8bu76", function(module, exports) {

$parcel$export(module.exports, "MessageWithFeedbackButton", () => $b9a82d82b671a2c2$export$e626981050b21e27);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $9C4ZQ = parcelRequire("9C4ZQ");
function $b9a82d82b671a2c2$export$e626981050b21e27(props) {
    const { message: message, linkText: linkText } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9a82d82b671a2c2$var$messageWrapperStyles,
        as: "span"
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9a82d82b671a2c2$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9C4ZQ.ReportToAtlassianButton), null, linkText)));
}
const $b9a82d82b671a2c2$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-block'
});
const $b9a82d82b671a2c2$var$messageWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("9C4ZQ", function(module, exports) {

$parcel$export(module.exports, "ReportToAtlassianButton", () => $e150638a8650974f$export$ee22a573c1320be1);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $65LL2 = parcelRequire("65LL2");

var $9W5pI = parcelRequire("9W5pI");

var $61ZjV = parcelRequire("61ZjV");
const $e150638a8650974f$export$ee22a573c1320be1 = ({ children: children })=>{
    const hasOpened = (0, $5uXOq.useRef)(false);
    const [isSubmitted, setSubmitted] = (0, $5uXOq.useState)(false);
    const [promptId] = (0, $9W5pI.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        // Only emit analytics event first time popup is opened
        if (!hasOpened.current) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiFeedback submitted', {
            aiFeatureName: 'NL Search in Jira',
            singleInstrumentationID: promptId,
            proactiveAIGenerated: 0,
            userGeneratedAI: 1,
            isAIFeature: 1,
            aiFeedbackResult: 'down'
        });
        hasOpened.current = true;
    }, [
        createAnalyticsEvent,
        promptId
    ]);
    const onSubmit = (0, $5uXOq.useCallback)(()=>setSubmitted(true), []);
    return isSubmitted ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65LL2.FeedbackButton), {
        appearance: "link",
        isErrorReport: true,
        isDisabled: isSubmitted,
        isPositive: false,
        onClick: onClick,
        onSubmit: onSubmit,
        offset: [
            8,
            16
        ],
        placement: "bottom-end",
        spacing: "none",
        label: typeof children === 'string' ? children : formatMessage((0, $61ZjV.default).reportToAtlassianDefault)
    }, children);
};

});
parcelRegister("65LL2", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $17075678c9ba99ec$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $9W5pI = parcelRequire("9W5pI");

var $cQwF0 = parcelRequire("cQwF0");

var $4xZbV = parcelRequire("4xZbV");
const $17075678c9ba99ec$export$116fedbe5e2e2bd8 = ({ appearance: appearance, children: children, iconBefore: iconBefore, isErrorReport: isErrorReport, isDisabled: isDisabled, isPositive: isPositive, isSelected: isSelected, label: label, onClick: onClick, onSubmit: onSubmit, offset: offset, placement: placement, spacing: spacing, testId: testId, tooltipContent: tooltipContent })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [submittedPrompt] = (0, $9W5pI.useSubmittedPrompt)();
    const [feedbackContext] = (0, $9W5pI.useResponseFeedbackContext)();
    const { onSubmitFeedback: onSubmitFeedback } = (0, $cQwF0.useFeedbackService)(submittedPrompt, feedbackContext);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        // Prevent opening of the popup if the click event has been explicity handled by the parent
        const handled = onClick();
        if (handled) return;
        setIsOpen(true);
    }, [
        onClick
    ]);
    const handleSubmit = (0, $5uXOq.useCallback)(async (data, isPositiveFeedback)=>{
        await onSubmitFeedback(data, isPositiveFeedback);
        onSubmit && onSubmit();
    }, [
        onSubmit,
        onSubmitFeedback
    ]);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: placement,
        offset: offset,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xZbV.FeedbackPopupContent), {
                isErrorReport: isErrorReport,
                isPositive: isPositive,
                onClose: handleClose,
                onSubmit: handleSubmit,
                setInitialFocusRef: setInitialFocusRef
            }),
        messageId: "atlassian-intelligence.common.ui.feedback-button.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: tooltipContent ?? null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                "aria-label": label,
                appearance: appearance,
                spacing: spacing,
                iconBefore: iconBefore,
                onClick: handleClick,
                isSelected: isSelected,
                isDisabled: isDisabled,
                testId: testId
            }, children))
    });
};

});
parcelRegister("cQwF0", function(module, exports) {

$parcel$export(module.exports, "useFeedbackService", () => $50d5817e7517d561$export$fdeb51de8e2ac66d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $bw7Gm = parcelRequire("bw7Gm");

var $leRCk = parcelRequire("leRCk");

var $4R6GH = parcelRequire("4R6GH");

var $l7ryR = parcelRequire("l7ryR");

var $5k7LC = parcelRequire("5k7LC");
var $50d5817e7517d561$require$Buffer = $5k7LC.Buffer;
const $50d5817e7517d561$var$FEEDBACK_ENDPOINT = '/gateway/api/feedback-collector-api/feedback';
const $50d5817e7517d561$var$REQUEST_TYPE = '594';
const $50d5817e7517d561$var$EMBED_KEY = 'a64ab7a8-2ce8-4942-884d-0f3090ef971e';
const $50d5817e7517d561$var$MAX_SUMMARY_LENGTH = 100;
// The custom fields for consent are defined in this file: src/packages/platform/ui/help-panel/src/services/feedback/index.tsx
// HOWEVER, they are not exported and as this feedback collector is expected to be a temporary solution the change hasn't been
// made to export them.
const $50d5817e7517d561$var$CONTACT_FIELD_ID = 'customfield_10043';
const $50d5817e7517d561$var$CONTACT_TRUE_VALUE = '10109';
const $50d5817e7517d561$var$CONTACT_FALSE_VALUE = '10111';
const $50d5817e7517d561$var$RESEARCH_FIELD_ID = 'customfield_10044';
const $50d5817e7517d561$var$RESEARCH_TRUE_VALUE = '10110';
const $50d5817e7517d561$var$RESEARCH_FALSE_VALUE = '10112';
const $50d5817e7517d561$var$FEEDBACK_SUBMITTED_FLAG = {
    id: (0, $7HGHK.toFlagId)('atlassian-intelligence.ui.prompt-response.feedback.submitted'),
    type: 'success',
    title: (0, $l7ryR.default).feedbackSubmittedFlagTitle,
    description: (0, $l7ryR.default).feedbackSubmittedFlagDescription,
    messageId: 'atlassian-intelligence.services.feedback.feedback-submitted-flag.success.jira-modal',
    messageType: 'transactional'
};
const $50d5817e7517d561$var$normalizeTextForSummary = (feedbackText)=>{
    if (!feedbackText.length) return '<no summary>';
    const singleLineFeedbackText = feedbackText.replace(/\n/g, ' ');
    return singleLineFeedbackText.length > $50d5817e7517d561$var$MAX_SUMMARY_LENGTH ? `${singleLineFeedbackText.substring(0, $50d5817e7517d561$var$MAX_SUMMARY_LENGTH)}...` : singleLineFeedbackText;
};
const $50d5817e7517d561$var$getFeedbackFieldsWithConsent = ({ data: data, feedbackContext: feedbackContext, isPositive: isPositive, emailAddress: emailAddress, displayName: displayName })=>{
    const { feedbackText: feedbackText, contactConsentPrompt: contactConsentPrompt, researchConsentPrompt: researchConsentPrompt } = data;
    return [
        {
            id: 'summary',
            value: `[${isPositive ? '+' : '-'}] ${$50d5817e7517d561$var$normalizeTextForSummary(feedbackText)}`
        },
        {
            id: 'description',
            value: feedbackText
        },
        {
            id: 'email',
            value: emailAddress ?? 'do-not-reply@atlassian.com'
        },
        {
            id: 'customfield_10045',
            value: displayName ?? 'unknown'
        },
        {
            id: 'aaidOrHash',
            value: ''
        },
        {
            id: 'customfield_10047',
            value: feedbackContext
        },
        {
            id: $50d5817e7517d561$var$CONTACT_FIELD_ID,
            value: [
                {
                    id: contactConsentPrompt ? $50d5817e7517d561$var$CONTACT_TRUE_VALUE : $50d5817e7517d561$var$CONTACT_FALSE_VALUE
                }
            ]
        },
        {
            id: $50d5817e7517d561$var$RESEARCH_FIELD_ID,
            value: [
                {
                    id: researchConsentPrompt ? $50d5817e7517d561$var$RESEARCH_TRUE_VALUE : $50d5817e7517d561$var$RESEARCH_FALSE_VALUE
                }
            ]
        }
    ];
};
const $50d5817e7517d561$var$normalizeFeedbackContext = (feedbackContext)=>feedbackContext.map(({ id: id, value: value })=>`${id}: ${value}`).join('\n');
const $50d5817e7517d561$var$removeName = (prompt, name)=>prompt.replace(new RegExp(name, 'gi'), 'XXX');
const $50d5817e7517d561$var$removeNames = (prompt, userFullname)=>userFullname.split(' ').reduce((acc, name)=>name === '' ? acc : $50d5817e7517d561$var$removeName(acc, name), prompt);
const $50d5817e7517d561$var$removeEmailAddresses = (prompt)=>prompt.replace(new RegExp('([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\\.[a-zA-Z0-9_-]+)', 'gi'), 'XXX@XXX.XXX');
const $50d5817e7517d561$export$53b1bdb22c0c1228 = (prompt, userFullname)=>$50d5817e7517d561$var$removeEmailAddresses($50d5817e7517d561$var$removeNames(prompt, userFullname));
const $50d5817e7517d561$export$fdeb51de8e2ac66d = (prompt, additionalFeedbackContext)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const onSubmitFeedback = (0, $5uXOq.useCallback)(async (data, isPositive)=>{
        if (!data.feedbackText && !data.sharePrompt) {
            showFlag($50d5817e7517d561$var$FEEDBACK_SUBMITTED_FLAG);
            // Do nothing, probably the user just wanted to send a thumbs up / thumbs down rating
            return Promise.resolve();
        }
        const feedbackContext = [
            {
                id: 'Location',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: (0, $bw7Gm.default)(window?.location?.href ?? '')
            },
            {
                id: 'Screen Resolution',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
            },
            {
                id: 'User-Agent',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.navigator?.userAgent ?? 'unknown'}`
            },
            {
                id: 'Rating',
                value: isPositive ? 'Thumbs up' : 'Thumbs down'
            }
        ];
        if (data.sharePrompt && prompt) feedbackContext.push({
            id: 'Prompt',
            value: $50d5817e7517d561$export$53b1bdb22c0c1228(prompt, loggedInUser?.displayName ?? '')
        });
        if (additionalFeedbackContext?.length && data.sharePrompt) feedbackContext.push(...additionalFeedbackContext);
        try {
            const body = JSON.stringify({
                feedback: {
                    requestType: $50d5817e7517d561$var$REQUEST_TYPE,
                    embedKey: $50d5817e7517d561$var$EMBED_KEY,
                    fields: $50d5817e7517d561$var$getFeedbackFieldsWithConsent({
                        data: data,
                        feedbackContext: $50d5817e7517d561$var$normalizeFeedbackContext(feedbackContext),
                        isPositive: isPositive,
                        emailAddress: loggedInUser?.emailAddress,
                        displayName: loggedInUser?.displayName
                    })
                }
            });
            await fetch($50d5817e7517d561$var$FEEDBACK_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: (0, $4R6GH.fg)('ai_search_allow_non_latin_characters_in_feedback') ? $50d5817e7517d561$require$Buffer.from(body).toString('base64') : btoa(body)
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onFeedbackSubmit',
                    packageName: 'jiraAtlassianIntelligence',
                    teamName: 'gravity-ai'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
        showFlag($50d5817e7517d561$var$FEEDBACK_SUBMITTED_FLAG);
        return Promise.resolve();
    }, [
        loggedInUser?.displayName,
        loggedInUser?.emailAddress,
        prompt,
        showFlag,
        additionalFeedbackContext
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            onSubmitFeedback: onSubmitFeedback
        }), [
        onSubmitFeedback
    ]);
};

});
parcelRegister("l7ryR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5cfb614d4111781$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b5cfb614d4111781$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedbackSubmittedFlagTitle: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-title",
        "defaultMessage": "Thank you for sharing your query"
    },
    feedbackSubmittedFlagDescription: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    }
});

});


parcelRegister("4xZbV", function(module, exports) {

$parcel$export(module.exports, "FeedbackPopupContent", () => $bd74bc0e79236698$export$9ca94f39d69b2936);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");

var $kkJfY = parcelRequire("kkJfY");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6LCpJ = parcelRequire("6LCpJ");

var $koVbs = parcelRequire("koVbs");

var $jAW0R = parcelRequire("jAW0R");
const $bd74bc0e79236698$var$FEEDBACK_TEXT_FIELD = 'feedback-text';
const $bd74bc0e79236698$var$SHARE_PROMPT_CHECKBOX = 'share-prompt';
const $bd74bc0e79236698$var$CONTACT_CONSENT_PROMPT_CHECKBOX = 'contact-consent-prompt';
const $bd74bc0e79236698$var$RESEARCH_CONSENT_PROMT_CHECKBOX = 'research-consent-prompt';
// The height of the text area should be 160px - there is a 12px combined padding and here we have 148px height
const $bd74bc0e79236698$var$MAX_TEXTAREA_HEIGHT = '148px';
const $bd74bc0e79236698$var$MIN_TEXTAREA_ROWS = 7;
const $bd74bc0e79236698$export$9ca94f39d69b2936 = ({ isErrorReport: isErrorReport, isPositive: isPositive, onClose: onClose, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [submitting, setSubmitting] = (0, $5uXOq.useState)(false);
    const handleOnSubmit = async (event)=>{
        event.preventDefault();
        if (!submitting) {
            setSubmitting(true);
            if (isErrorReport) await onSubmit({
                feedbackText: '',
                sharePrompt: true,
                contactConsentPrompt: false,
                researchConsentPrompt: false
            }, isPositive);
            else {
                const data = new FormData(event.currentTarget);
                const feedbackText = data.get($bd74bc0e79236698$var$FEEDBACK_TEXT_FIELD)?.toString() ?? '';
                const sharePrompt = data.get($bd74bc0e79236698$var$SHARE_PROMPT_CHECKBOX) === $bd74bc0e79236698$var$SHARE_PROMPT_CHECKBOX;
                const contactConsentPrompt = data.get($bd74bc0e79236698$var$CONTACT_CONSENT_PROMPT_CHECKBOX) === $bd74bc0e79236698$var$CONTACT_CONSENT_PROMPT_CHECKBOX;
                const researchConsentPrompt = data.get($bd74bc0e79236698$var$RESEARCH_CONSENT_PROMT_CHECKBOX) === $bd74bc0e79236698$var$RESEARCH_CONSENT_PROMT_CHECKBOX;
                await onSubmit({
                    feedbackText: feedbackText,
                    sharePrompt: sharePrompt,
                    contactConsentPrompt: contactConsentPrompt,
                    researchConsentPrompt: researchConsentPrompt
                }, isPositive);
            }
            setSubmitting(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.300",
        xcss: $bd74bc0e79236698$var$containerStyles,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.feedback-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
        onSubmit: handleOnSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, formatMessage((0, $jAW0R.default).heading)), !isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": formatMessage((0, $jAW0R.default).close),
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $jAW0R.default).close)
        }),
        onClick: onClose,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.close-button"
    }))), isErrorReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, formatMessage((0, $jAW0R.default).errorReportDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $jAW0R.default).textAreaHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd74bc0e79236698$var$textAreaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
        name: $bd74bc0e79236698$var$FEEDBACK_TEXT_FIELD,
        appearance: "none",
        minimumRows: $bd74bc0e79236698$var$MIN_TEXTAREA_ROWS,
        maxHeight: $bd74bc0e79236698$var$MAX_TEXTAREA_HEIGHT // This keeps the text area at a constant height alongside min rows
        ,
        "aria-label": formatMessage((0, $jAW0R.default).textAreaHeader),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.text-area",
        ref: setInitialFocusRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        name: $bd74bc0e79236698$var$SHARE_PROMPT_CHECKBOX,
        value: $bd74bc0e79236698$var$SHARE_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $jAW0R.default).shareQueryPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.share-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        name: $bd74bc0e79236698$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        value: $bd74bc0e79236698$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $jAW0R.default).contactConsentPromptJnlis612, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                    target: "_blank"
                }, chunks)
        })),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.contact-consent-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        name: $bd74bc0e79236698$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        value: $bd74bc0e79236698$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $jAW0R.default).researchConsentPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.research-consent-prompt-checkbox"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignInline: "end"
    }, isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        type: "button",
        onClick: onClose
    }, formatMessage((0, $jAW0R.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        type: "submit",
        appearance: "primary",
        isLoading: submitting,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.submit-button"
    }, formatMessage(isErrorReport ? (0, $jAW0R.default).shareQuery : (0, $jAW0R.default).sendFeedback))))));
};
const $bd74bc0e79236698$var$containerStyles = (0, $8CUq3.xcss)({
    width: '448px',
    borderRadius: 'border.radius'
});
const $bd74bc0e79236698$var$textAreaContainerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.input',
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `2px solid ${"var(--ds-border-input, #8590A2)"}`,
    marginBottom: 'space.200'
});

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});

parcelRegister("jAW0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c2ebf7315b2679$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $54c2ebf7315b2679$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorReportDescription: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.error-report-description",
        "defaultMessage": "Share your query to help us improve search results."
    },
    shareQuery: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.share-query",
        "defaultMessage": "Share Query"
    },
    cancel: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.cancel",
        "defaultMessage": "Cancel"
    },
    heading: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.heading",
        "defaultMessage": "Help us improve Atlassian Intelligence"
    },
    close: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.close",
        "defaultMessage": "Close"
    },
    sendFeedback: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.send-feedback",
        "defaultMessage": "Send feedback"
    },
    contactConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt",
        "defaultMessage": "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <link>Atlassian Privacy Policy</link>."
    },
    researchConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt",
        "defaultMessage": "I'd like to participate in product research."
    },
    textAreaHeader: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.text-area-header",
        "defaultMessage": "How was your search experience?"
    },
    shareQueryPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.share-query-prompt-jnlis-612",
        "defaultMessage": "Include my search query and response in my feedback"
    },
    contactConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt-jnlis-612",
        "defaultMessage": "Atlassian can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>"
    },
    researchConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt-jnlis-612",
        "defaultMessage": "I want to participate in Atlassian\u2019s product research"
    }
});

});



parcelRegister("61ZjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b263065f57b30aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b263065f57b30aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reportToAtlassianDefault: {
        "id": "atlassian-intelligence.prompt-response.report-to-atlassian-button.report-to-atlassian-default",
        "defaultMessage": "Report to Atlassian"
    }
});

});



parcelRegister("hQRtt", function(module, exports) {

$parcel$export(module.exports, "MessageWithSupportLink", () => $935baef38f5e7621$export$d20e11a08c36750a);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $ousew = parcelRequire("ousew");
function $935baef38f5e7621$export$d20e11a08c36750a(props) {
    const { message: message, href: href = '' } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...message,
        values: {
            support_link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    spacing: "none",
                    href: href,
                    appearance: "link"
                }, chunks)
        }
    });
}

});

parcelRegister("10A71", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97a590266d53cbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c97a590266d53cbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noJqlReturned: {
        "id": "natural-language-to-jql.services.use-natural-language-to-jql.no-jql-returned",
        "defaultMessage": "We couldn\u2019t turn your input into a JQL query. Try adding more details."
    },
    invalidJqlErrorNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final",
        "defaultMessage": "Atlassian Intelligence couldn\u2019t process your query. Try including specific fields from your issues or projects."
    },
    errorRateLimit: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.error-rate-limit",
        "defaultMessage": "Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <support_link>in our support documentation</support_link>."
    },
    helpUsImproveNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.help-us-improve-non-final",
        "defaultMessage": "Help us improve your search"
    },
    unsupportedLanguageErrorNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.unsupported-language-error-non-final",
        "defaultMessage": "Atlassian Intelligence currently can\u2019t translate non-English words. Try editing your query."
    },
    serverError: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.server-error",
        "defaultMessage": "Atlassian Intelligence can't provide a response right now. Read more <support_link>in our support documentation</support_link>."
    },
    invalidJqlErrorNonFinalIssueTerminologyRefreshM4: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final-issue-terminology-refresh-m4",
        "defaultMessage": "Atlassian Intelligence couldn\u2019t process your query. Try including specific fields from your work items or projects."
    }
});

});



parcelRegister("5Ys8c", function(module, exports) {

$parcel$export(module.exports, "Container", () => $6f0d7f55a7584476$export$42a852a2b6b56249);
$parcel$export(module.exports, "useIsAITourEnabled", () => $6f0d7f55a7584476$export$86ae6680aa96ab9c);
$parcel$export(module.exports, "useAITourActions", () => $6f0d7f55a7584476$export$4749bc2ffa4650e0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $iqyeC = parcelRequire("iqyeC");
const $6f0d7f55a7584476$var$initialState = {
    isAITourEnabled: false
};
const $6f0d7f55a7584476$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $6f0d7f55a7584476$var$initialState,
    actions: $iqyeC.actions
});
const $6f0d7f55a7584476$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($6f0d7f55a7584476$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState }, { isAITourUserPreferenceEnabled: isAITourUserPreferenceEnabled })=>{
            setState({
                isAITourEnabled: isAITourUserPreferenceEnabled
            });
        }
});
const $6f0d7f55a7584476$export$86ae6680aa96ab9c = (0, $3sQ5x.createHook)($6f0d7f55a7584476$export$390f32400eaf98c9, {
    selector: (state)=>state.isAITourEnabled
});
const $6f0d7f55a7584476$export$4749bc2ffa4650e0 = (0, $3sQ5x.createActionsHook)($6f0d7f55a7584476$export$390f32400eaf98c9);

});
parcelRegister("iqyeC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1198963efbaa76ee$export$e324594224ef24da);
const $1198963efbaa76ee$export$e324594224ef24da = {
    onDisableAITourUserPreference: ()=>(_, { onDisableAITourUserPreference: onDisableAITourUserPreference })=>{
            onDisableAITourUserPreference();
        },
    onEndAITour: ()=>({ setState: setState })=>{
            setState({
                isAITourEnabled: false
            });
        }
};

});


parcelRegister("inRfC", function(module, exports) {

$parcel$export(module.exports, "usePlaceholders", () => $c869176f328b1d5a$export$70db0766be197dab);

var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $s7Ri8 = parcelRequire("s7Ri8");

var $l31KD = parcelRequire("l31KD");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");
const $c869176f328b1d5a$var$getInitialState = (project = 'Donut Plains')=>{
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const projectScopedPlaceholders = [
        `Find work items in project "${project}" that are assigned to me`,
        `What are the highest priority bugs in project "${project}"?`,
        `Stories in project "${project}" updated this month`,
        `Which tasks in project "${project}" don't have an assignee?`,
        `Find work items in project "${project}" that were created in the last 30 days`
    ];
    const projectScopedPlaceholdersOld = [
        `Find issues in project "${project}" that are assigned to me`,
        `What are the highest priority bugs in project "${project}"?`,
        `Stories in project "${project}" updated this month`,
        `Which tasks in project "${project}" don't have an assignee?`,
        `Find issues in project "${project}" that were created in the last 30 days`
    ];
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const globalScopedPlaceholders = [
        'Work items about pizza forest with status rolling out',
        'Which epics are in progress?',
        "Find work items that I'm watching",
        'Work items reported by Mike and ordered by priority'
    ];
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const globalScopedPlaceholdersOld = [
        'Issues about pizza forest with status rolling out',
        'Which epics are in progress?',
        "Find issues that I'm watching",
        'Issues reported by Mike and ordered by priority'
    ];
    // Randomize order of the placeholders above, making sure a project scoped placeholder always comes first
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))((0, (/*@__PURE__*/$parcel$interopDefault($l31KD)))((0, (/*@__PURE__*/$parcel$interopDefault($s7Ri8)))((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? projectScopedPlaceholders : projectScopedPlaceholdersOld), (0, (/*@__PURE__*/$parcel$interopDefault($s7Ri8)))((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? globalScopedPlaceholders : globalScopedPlaceholdersOld))).filter((placeholder)=>placeholder !== undefined);
};
const $c869176f328b1d5a$export$70db0766be197dab = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    return (0, $5uXOq.useMemo)(()=>$c869176f328b1d5a$var$getInitialState(projectContext?.projectKey), [
        projectContext?.projectKey
    ]);
};

});
parcelRegister("l31KD", function(module, exports) {

var $g7i7g = parcelRequire("g7i7g");

var $7mmCD = parcelRequire("7mmCD");
/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */ var $f52b3c835db22ca2$var$zip = $g7i7g($7mmCD);
module.exports = $f52b3c835db22ca2$var$zip;

});
parcelRegister("7mmCD", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $1nIHN = parcelRequire("1nIHN");

var $8hdQS = parcelRequire("8hdQS");

var $l2xln = parcelRequire("l2xln");

var $f3SOL = parcelRequire("f3SOL");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $55bc22bd03f7be58$var$nativeMax = Math.max;
/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */ function $55bc22bd03f7be58$var$unzip(array) {
    if (!(array && array.length)) return [];
    var length = 0;
    array = $2GdQn(array, function(group) {
        if ($f3SOL(group)) {
            length = $55bc22bd03f7be58$var$nativeMax(group.length, length);
            return true;
        }
    });
    return $l2xln(length, function(index) {
        return $1nIHN(array, $8hdQS(index));
    });
}
module.exports = $55bc22bd03f7be58$var$unzip;

});



parcelRegister("ekmxu", function(module, exports) {

$parcel$export(module.exports, "AlertMessage", () => $30a0faa0d212a520$export$8ebcecbecdb22732);

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");
const $30a0faa0d212a520$export$8ebcecbecdb22732 = ({ appearance: appearance, children: children, testId: testId })=>{
    const StyleConfig = $30a0faa0d212a520$var$getIconAndStyles(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        testId: testId,
        space: "space.050",
        xcss: StyleConfig.styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyleConfig.Icon, {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, children));
};
const $30a0faa0d212a520$var$infoStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle'
});
const $30a0faa0d212a520$var$warningStyles = (0, $8CUq3.xcss)({
    color: 'color.text.warning'
});
const $30a0faa0d212a520$var$errorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.danger'
});
const $30a0faa0d212a520$var$getIconAndStyles = (appearence)=>{
    switch(appearence){
        case 'info':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
                styles: $30a0faa0d212a520$var$infoStyles
            };
        case 'warning':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
                styles: $30a0faa0d212a520$var$warningStyles
            };
        case 'error':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
                styles: $30a0faa0d212a520$var$errorStyles
            };
        default:
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
                styles: $30a0faa0d212a520$var$infoStyles
            };
    }
};

});

parcelRegister("bj2da", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebba2b7ba11fca3e$export$2e2bcd8739ae039);

var $1ZRmh = parcelRequire("1ZRmh");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $032ey = parcelRequire("032ey");

var $ifQ0j = parcelRequire("ifQ0j");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1ZQ4t = parcelRequire("1ZQ4t");
const $ebba2b7ba11fca3e$var$CustomEditorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showAdvancedEditor: showAdvancedEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n",
            __cmplp.showAdvancedEditor ? "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr" : "_1n261g80 _19pkr5cr _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $ebba2b7ba11fca3e$var$components = {
    SearchModeSwitcher: $1ZQ4t.SearchModeSwitcher,
    EditorContainer: $ebba2b7ba11fca3e$var$CustomEditorContainer
};
const $ebba2b7ba11fca3e$var$JQLBuilderEmbedded = ({ aiBuilderOverrides: aiBuilderOverrides, generatedJql: generatedJql, query: query, jqlMessages: jqlMessages, onSearch: onSearch, renderExtraControls: renderExtraControls, userPreferences: userPreferences, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleSearch = (0, $5uXOq.useCallback)((jql)=>{
        onSearch && onSearch(jql);
        const isModified = generatedJql !== jql;
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'jqlBuilderEmbedded', {
            isModified: isModified
        });
    }, [
        createAnalyticsEvent,
        generatedJql,
        onSearch
    ]); // Allow renderExtraControls to be overridden for the embedded AI view.
    const renderExtraControlsOverride = aiBuilderOverrides?.renderExtraControls ?? renderExtraControls;
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $1ZRmh.default), userPreferences);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifQ0j.default), {
        ...props,
        userPreferencesData: userPreferencesData ?? null,
        query: query,
        jqlMessages: jqlMessages,
        onSearch: onSearch ? handleSearch : undefined,
        renderExtraControls: renderExtraControlsOverride,
        components: $ebba2b7ba11fca3e$var$components,
        searchModeSwitcherLocation: (0, $032ey.SEARCH_MODE_SWITCHER_RIGHT_LOCATION)
    });
};
var $ebba2b7ba11fca3e$export$2e2bcd8739ae039 = $ebba2b7ba11fca3e$var$JQLBuilderEmbedded;

});
parcelRegister("1ZRmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7b07efe333dee7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<515fc3ab26c9c35442907db000dfbc24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df7b07efe333dee7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilderEmbedded_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_jqlBuilder_JQLBuilder"
        }
    ],
    "type": "JiraUserPreferences"
};
$df7b07efe333dee7$var$node.hash = "ff5e8454ba99d859ec81e83043c22b46";
var $df7b07efe333dee7$export$2e2bcd8739ae039 = $df7b07efe333dee7$var$node;

});

parcelRegister("1ZQ4t", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcher", () => $9563a72998c31bd1$export$639730063e548c7);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");

var $64ZXt = parcelRequire("64ZXt");

var $4oQkP = parcelRequire("4oQkP");

var $lEBr4 = parcelRequire("lEBr4");
const $9563a72998c31bd1$export$639730063e548c7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64ZXt.Feedback), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oQkP.DisclaimerTooltip), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lEBr4.SearchModeOverflowMenu), props));

});
parcelRegister("64ZXt", function(module, exports) {

$parcel$export(module.exports, "Feedback", () => $ab9a89af9227480b$export$175e500a48a60fd2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3xPiH = parcelRequire("3xPiH");

var $f5TWP = parcelRequire("f5TWP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $65LL2 = parcelRequire("65LL2");

var $9W5pI = parcelRequire("9W5pI");


var $2638C = parcelRequire("2638C");
const $ab9a89af9227480b$var$LikeIcon = ({ isSelected: isSelected = false, isDisabled: isDisabled = false, label: label })=>{
    const primaryColor = isSelected || isDisabled ? undefined : "var(--ds-icon-accent-gray, #758195)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xPiH))), {
        spacing: "spacious",
        label: label,
        color: primaryColor,
        LEGACY_primaryColor: primaryColor
    });
};
const $ab9a89af9227480b$var$DislikeIcon = (props)=>// TODO: after visual refresh is completely rolled out, change it to import ThumbsDownIcon from '@atlaskit/icon/core/thumbs-down';
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ab9a89af9227480b$var$Flip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ab9a89af9227480b$var$LikeIcon, props));
const $ab9a89af9227480b$export$175e500a48a60fd2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selected, setSelected] = (0, $5uXOq.useState)((0, $cbaee2d90d5dae3d$export$c53d0f541b41b88e));
    const hasOpened = (0, $5uXOq.useRef)(false);
    const [isLoading] = (0, $9W5pI.usePromptIsLoading)();
    const [promptId] = (0, $9W5pI.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // Reset internal state whenever a new prompt has been submitted so more feedback can be given
        if (!isLoading) {
            setSelected((0, $cbaee2d90d5dae3d$export$c53d0f541b41b88e));
            hasOpened.current = false;
        }
    }, [
        isLoading
    ]);
    const onRating = (0, $5uXOq.useCallback)((feedbackType)=>()=>{
            setSelected(feedbackType); // Only emit analytics event first time popup is opened
            if (!hasOpened.current) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiFeedback submitted', {
                aiFeatureName: 'NL Search in Jira',
                singleInstrumentationID: promptId,
                proactiveAIGenerated: 0,
                userGeneratedAI: 1,
                isAIFeature: 1,
                aiFeedbackResult: feedbackType === 'LIKE' ? 'up' : 'down'
            });
            hasOpened.current = true;
            return false;
        }, [
        createAnalyticsEvent,
        promptId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65LL2.FeedbackButton), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ab9a89af9227480b$var$LikeIcon, {
            label: formatMessage((0, $2638C.default).jnlis645GoodResponse),
            isSelected: selected === (0, $a56b51abbcbea207$export$d0f488901b85b750),
            isDisabled: isLoading
        }),
        isDisabled: isLoading,
        isPositive: true,
        isSelected: selected === (0, $a56b51abbcbea207$export$d0f488901b85b750),
        onClick: onRating((0, $a56b51abbcbea207$export$d0f488901b85b750)),
        offset: [
            40,
            16
        ],
        placement: "bottom-end",
        spacing: "compact",
        testId: "atlassian-intelligence.ui.feedback.like-button",
        tooltipContent: selected === (0, $cbaee2d90d5dae3d$export$c53d0f541b41b88e) && formatMessage((0, $2638C.default).jnlis645GoodResponse),
        label: formatMessage((0, $2638C.default).jnlis645GoodResponse)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65LL2.FeedbackButton), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ab9a89af9227480b$var$DislikeIcon, {
            label: formatMessage((0, $2638C.default).jnlis645BadResponse),
            isSelected: selected === (0, $a56b51abbcbea207$export$7ca6708a8b83d828),
            isDisabled: isLoading
        }),
        isDisabled: isLoading,
        isPositive: false,
        isSelected: selected === (0, $a56b51abbcbea207$export$7ca6708a8b83d828),
        onClick: onRating((0, $a56b51abbcbea207$export$7ca6708a8b83d828)),
        offset: [
            8,
            16
        ],
        placement: "bottom-end",
        spacing: "compact",
        testId: "atlassian-intelligence.ui.feedback.dislike-button",
        tooltipContent: selected === (0, $cbaee2d90d5dae3d$export$c53d0f541b41b88e) && formatMessage((0, $2638C.default).jnlis645BadResponse),
        label: formatMessage((0, $2638C.default).jnlis645BadResponse)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ab9a89af9227480b$var$Flip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec1sub",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xPiH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34d7d17224c47dbf743afe51a06a375>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $294c3f642027df65$var$_react = $294c3f642027df65$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $294c3f642027df65$var$_thumbsUp = $294c3f642027df65$var$_interopRequireDefault((parcelRequire("8AQ0R")));

var $294c3f642027df65$var$_like = $294c3f642027df65$var$_interopRequireDefault((parcelRequire("kxkv9")));
function $294c3f642027df65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ThumbsUpIcon.
 * This component is ThumbsUpIcon, with `UNSAFE_fallbackIcon` set to "LikeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $294c3f642027df65$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $294c3f642027df65$var$_react.default.createElement($294c3f642027df65$var$_thumbsUp.default, Object.assign({
        LEGACY_fallbackIcon: $294c3f642027df65$var$_like.default
    }, props));
$294c3f642027df65$var$ThumbsUpIcon.Name = 'ThumbsUpIconMigration';
var $294c3f642027df65$var$_default = module.exports.default = $294c3f642027df65$var$ThumbsUpIcon;

});
parcelRegister("8AQ0R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $641a0838d2f101d6$var$_react = $641a0838d2f101d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $641a0838d2f101d6$var$_baseNew = $641a0838d2f101d6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $641a0838d2f101d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $641a0838d2f101d6$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $641a0838d2f101d6$var$_react.default.createElement($641a0838d2f101d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$641a0838d2f101d6$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $641a0838d2f101d6$var$_default = module.exports.default = $641a0838d2f101d6$var$ThumbsUpIcon;

});

parcelRegister("kxkv9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef36cadea8660550$var$_react = $ef36cadea8660550$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ef36cadea8660550$var$_thumbsUp = $ef36cadea8660550$var$_interopRequireDefault((parcelRequire("8AQ0R")));
function $ef36cadea8660550$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef36cadea8660550$var$LikeIcon = (props)=>/*#__PURE__*/ $ef36cadea8660550$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 12v7a.97.97 0 0 0 .278.704 1 1 0 0 0 .701.296H6v-9H4.98a1 1 0 0 0-.701.296A.97.97 0 0 0 4 12m15.281-.96a3.05 3.05 0 0 0-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.43 2.43 0 0 0 12.075 4a3.08 3.08 0 0 0-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2 2 0 0 0-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 0 0 2.997-2.507l.677-4a2.96 2.96 0 0 0-.677-2.432m-1.998 6.1a1.01 1.01 0 0 1-1 .835H9.038v-6.269l.767-1.089a7.6 7.6 0 0 0 1.302-3.509c.036-.543.255-1.209.969-1.108s.575 1.916.363 3.1a20 20 0 0 1-.868 2.882l5.39-.008c.297-.001.58.128.773.352a1 1 0 0 1 .226.813z"/></svg>`
    }, props, {
        newIcon: $ef36cadea8660550$var$_thumbsUp.default
    }));
$ef36cadea8660550$var$LikeIcon.displayName = 'LikeIcon';
var $ef36cadea8660550$var$_default = module.exports.default = $ef36cadea8660550$var$LikeIcon;

});


const $cbaee2d90d5dae3d$export$c53d0f541b41b88e = 'NONE';

parcelRegister("2638C", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e414fb4e4e2a0c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e414fb4e4e2a0c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jnlis645GoodResponse: {
        "id": "atlassian-intelligence.prompt-response.feedback.jnlis645-good-response",
        "defaultMessage": "Good response"
    },
    jnlis645BadResponse: {
        "id": "atlassian-intelligence.prompt-response.feedback.jnlis645-bad-response",
        "defaultMessage": "Bad response"
    }
});

});


parcelRegister("4oQkP", function(module, exports) {

$parcel$export(module.exports, "DisclaimerTooltip", () => $71e4e94d9681981a$export$e0db5370c1c8da59);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $1jWct = parcelRequire("1jWct");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $864QZ = parcelRequire("864QZ");
const $71e4e94d9681981a$var$DISCLAIMER_PAGE_HREF = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $71e4e94d9681981a$export$e0db5370c1c8da59 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const handleTrustDisclaimerClicked = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiTrustDisclaimer');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom",
        messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $71e4e94d9681981a$var$PopupStyles
            }, formatMessage((0, $864QZ.default).aiDisclaimerPopupContent, {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($71e4e94d9681981a$var$Link, {
                        href: $71e4e94d9681981a$var$DISCLAIMER_PAGE_HREF,
                        target: "_blank",
                        onClick: handleTrustDisclaimerClicked
                    }, chunks)
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $864QZ.default).infoIconTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $864QZ.default).infoIconLabel),
                "aria-label": formatMessage((0, $864QZ.default).infoIconLabel),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                    label: "",
                    LEGACY_size: "small",
                    color: "var(--ds-icon-accent-gray, #758195)"
                }),
                onClick: ()=>setIsPopupOpen(!isPopupOpen),
                ...triggerProps
            }))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $71e4e94d9681981a$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});
const $71e4e94d9681981a$var$PopupStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    background: 'color.background.input',
    padding: 'space.200',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay'
});

});
parcelRegister("864QZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2817f52544f03d79$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2817f52544f03d79$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    aiDisclaimerPopupContent: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.ai-disclaimer-popup-content",
        "defaultMessage": "The quality of AI-generated information may vary. <a>Learn why</a>"
    },
    infoIconLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-label",
        "defaultMessage": "Atlassian Intelligence trust information."
    },
    infoIconTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-tooltip",
        "defaultMessage": "About AI"
    }
});

});


parcelRegister("lEBr4", function(module, exports) {

$parcel$export(module.exports, "SearchModeOverflowMenu", () => $e082d36c9950c4ae$export$bd8d5aab7316dc82);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $a3mGm = parcelRequire("a3mGm");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVY0Y = parcelRequire("lVY0Y");

var $eyja0 = parcelRequire("eyja0");
const $e082d36c9950c4ae$var$TooltipWithDisplayInlineFix = (props)=>// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript) */}
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: $e082d36c9950c4ae$var$CustomTooltipTag,
        ...props
    });
const $e082d36c9950c4ae$export$bd8d5aab7316dc82 = ({ defaultOpen: defaultOpen = false, ...searchModeSwitcherProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOpenChange = ({ isOpen: isOpen })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: isOpen ? 'opened' : 'closed',
            actionSubject: 'dropdown'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiSearchModeMenu');
    };
    const handlePrivacyAndLegalClicked = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiPrivacyAndLegal');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e082d36c9950c4ae$var$TooltipWithDisplayInlineFix, {
                hideTooltipOnClick: true,
                content: formatMessage((0, $lVY0Y.messages).dropdownButtonTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                spacing: "none",
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: formatMessage((0, $lVY0Y.messages).overflowMenuLabel)
                }),
                ref: triggerRef
            })),
        onOpenChange: handleOpenChange,
        defaultOpen: defaultOpen,
        spacing: "compact",
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyja0.SearchModeToggleMenuItem), searchModeSwitcherProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3mGm))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank",
        onClick: handlePrivacyAndLegalClicked
    }, formatMessage((0, $lVY0Y.messages).dataAndPrivacy))));
};
// The following inline-flex fix is for making the "More" icon be aligned with the rest of the feedback buttons
// Prior to this change, this was aligned correctly only because the "More" button had a height of 32px (which is wrong according to the design)
// When the height is fixed, this is no longer working due to the built in styles of the Tooltip
// Hence we override the display property of the tag to inline-flex, so that it is aligned to the center
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e082d36c9950c4ae$var$CustomTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("lVY0Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8f64914b25e37032$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8f64914b25e37032$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dropdownButtonTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.dropdown-button-tooltip",
        "defaultMessage": "More actions"
    },
    dataAndPrivacy: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.data-and-privacy",
        "defaultMessage": "Data & Privacy"
    },
    overflowMenuLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.overflow-menu-label",
        "defaultMessage": "More query builder options"
    }
});

});

parcelRegister("eyja0", function(module, exports) {

$parcel$export(module.exports, "SearchModeToggleMenuItem", () => $f3cadb7fe5a2feac$export$e2cd8687a50b5163);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $2ciBJ = parcelRequire("2ciBJ");

var $biU84 = parcelRequire("biU84");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $032ey = parcelRequire("032ey");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ekhOu = parcelRequire("ekhOu");
const $f3cadb7fe5a2feac$export$e2cd8687a50b5163 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleUpdateSearchMode = ()=>{
        const nextSearchMode = searchMode === (0, $032ey.SEARCH_MODE_BASIC) ? (0, $032ey.SEARCH_MODE_ADVANCED) : (0, $032ey.SEARCH_MODE_BASIC);
        onUpdateSearchMode(nextSearchMode);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiSearchModeToggle', {
            searchMode: (0, $032ey.mapSearchModeToAnalyticAtribute)[nextSearchMode]
        });
    };
    if (searchMode === (0, $032ey.SEARCH_MODE_BASIC)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleUpdateSearchMode,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2ciBJ))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $ekhOu.messages).advancedModeOverflowMenu));
    const switchToBasicItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: isBasicModeDisabled,
        onClick: handleUpdateSearchMode,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($biU84))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $ekhOu.messages).basicModeOverflowMenu));
    return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ekhOu.messages).basicModeDisabledTooltip),
        tag: "span"
    }, switchToBasicItem) : switchToBasicItem;
};

});
parcelRegister("2ciBJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $199b22d6246a3269$var$_react = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $199b22d6246a3269$var$_angleBrackets = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("jSlaY")));

var $199b22d6246a3269$var$_code = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("c2JK5")));
function $199b22d6246a3269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $199b22d6246a3269$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $199b22d6246a3269$var$_react.default.createElement($199b22d6246a3269$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $199b22d6246a3269$var$_code.default
    }, props));
$199b22d6246a3269$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $199b22d6246a3269$var$_default = module.exports.default = $199b22d6246a3269$var$AngleBracketsIcon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});

parcelRegister("c2JK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c49276b1d591265$var$_react = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8c49276b1d591265$var$_angleBrackets = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $8c49276b1d591265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8c49276b1d591265$var$CodeIcon = (props)=>/*#__PURE__*/ $8c49276b1d591265$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $8c49276b1d591265$var$_angleBrackets.default
    }));
$8c49276b1d591265$var$CodeIcon.displayName = 'CodeIcon';
var $8c49276b1d591265$var$_default = module.exports.default = $8c49276b1d591265$var$CodeIcon;

});


parcelRegister("biU84", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afb010b77a3674d977e5adddea745303>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83acea36e9e8e9ba$var$_react = $83acea36e9e8e9ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83acea36e9e8e9ba$var$_component = $83acea36e9e8e9ba$var$_interopRequireDefault((parcelRequire("ehis8")));

var $83acea36e9e8e9ba$var$_component2 = $83acea36e9e8e9ba$var$_interopRequireDefault((parcelRequire("7dTJQ")));
function $83acea36e9e8e9ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ComponentIcon.
 * This component is ComponentIcon, with `UNSAFE_fallbackIcon` set to "ComponentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83acea36e9e8e9ba$var$ComponentIcon = (props)=>/*#__PURE__*/ $83acea36e9e8e9ba$var$_react.default.createElement($83acea36e9e8e9ba$var$_component.default, Object.assign({
        LEGACY_fallbackIcon: $83acea36e9e8e9ba$var$_component2.default
    }, props));
$83acea36e9e8e9ba$var$ComponentIcon.Name = 'ComponentIconMigration';
var $83acea36e9e8e9ba$var$_default = module.exports.default = $83acea36e9e8e9ba$var$ComponentIcon;

});
parcelRegister("ehis8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a650f78d49c8cbb1$var$_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>/*#__PURE__*/ $a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;

});

parcelRegister("7dTJQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5424fbcfeb6a920c$var$_react = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5424fbcfeb6a920c$var$_component = $5424fbcfeb6a920c$var$_interopRequireDefault((parcelRequire("ehis8")));
function $5424fbcfeb6a920c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5424fbcfeb6a920c$var$ComponentIcon = (props)=>/*#__PURE__*/ $5424fbcfeb6a920c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $5424fbcfeb6a920c$var$_component.default
    }));
$5424fbcfeb6a920c$var$ComponentIcon.displayName = 'ComponentIcon';
var $5424fbcfeb6a920c$var$_default = module.exports.default = $5424fbcfeb6a920c$var$ComponentIcon;

});


parcelRegister("ekhOu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb11d10075dd59a6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $cb11d10075dd59a6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    basicModeDisabledTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicModeOverflowMenu: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-overflow-menu",
        "defaultMessage": "Switch to Basic"
    },
    advancedModeOverflowMenu: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.advanced-mode-overflow-menu",
        "defaultMessage": "Switch to JQL"
    }
});

});





parcelRegister("79sYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $44de0cf32260a224$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $44de0cf32260a224$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.skip",
        "defaultMessage": "Skip"
    },
    next: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.next",
        "defaultMessage": "Next"
    },
    done: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.done",
        "defaultMessage": "Done"
    },
    globalTourHeading: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-heading",
        "defaultMessage": "Use AI to find issues faster"
    },
    globalTourBody: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-body",
        "defaultMessage": "Search for issues with Atlassian Intelligence instead of coming up with complex queries."
    },
    tourHeading: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.tour-heading",
        "defaultMessage": "Just start typing"
    },
    tourBody: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.tour-body",
        "defaultMessage": "The more detail you give us, the more accurate the search results."
    },
    backButtonLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.back-button-label",
        "defaultMessage": "Back - Exit Atlassian Intelligence and return to Basic or JQL search"
    },
    jqlTooComplex: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-too-complex",
        "defaultMessage": "This query is too complex for Basic mode. Atlassian Intelligence has switched to JQL mode to improve results."
    },
    globalTourHeadingIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Use AI to find work items faster"
    },
    globalTourBodyIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-body-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items with Atlassian Intelligence instead of coming up with complex queries."
    }
});

});


parcelRegister("8ej2m", function(module, exports) {

$parcel$export(module.exports, "NaturalLanguageToggle", () => $40fa2792d27558bd$export$452ca96ca3dd2544);

var $4QEHp = parcelRequire("4QEHp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k6T4f = parcelRequire("k6T4f");

var $4R6GH = parcelRequire("4R6GH");

var $jDegt = parcelRequire("jDegt");

var $koVbs = parcelRequire("koVbs");

var $761Hb = parcelRequire("761Hb");

var $8QPci = parcelRequire("8QPci");

var $qLuSt = parcelRequire("qLuSt");

var $2jDmD = parcelRequire("2jDmD");

var $8zOmE = parcelRequire("8zOmE");

var $512eM = parcelRequire("512eM");

var $6s1PB = parcelRequire("6s1PB");

var $5Ys8c = parcelRequire("5Ys8c");

var $jfJ6h = parcelRequire("jfJ6h");
function $40fa2792d27558bd$var$deriveAiState(data) {
    const disabledAiState = {
        aiAvailable: false,
        aiEnabled: false
    };
    const action = data?.atlassianIntelligenceAction;
    if (!action) return disabledAiState;
    // Case 1: AI is available, but disabled, and non org admins are notified
    if (action.__typename === 'JiraContactOrgAdminToEnableAtlassianIntelligence') return {
        aiAvailable: true,
        aiEnabled: false,
        isOrgAdmin: false,
        orgAdminLink: null
    };
    // Case 2: AI is available, but disabled, and org admins are guided to the admin hub
    if (action?.__typename === 'JiraEnableAtlassianIntelligenceDeepLink' && action?.link) return {
        aiAvailable: true,
        aiEnabled: false,
        isOrgAdmin: true,
        orgAdminLink: action.link
    };
    // Case 3: AI is available, and enabled
    if (action?.__typename === 'JiraAccessAtlassianIntelligenceFeature' && action.isAccessible) return {
        aiAvailable: true,
        aiEnabled: true
    };
    // Default to AI unavailable
    return disabledAiState;
}
const $40fa2792d27558bd$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $40fa2792d27558bd$var$analyticsEventName = 'jqlBuilderAiToggle';
const $40fa2792d27558bd$export$452ca96ca3dd2544 = ({ autoFocus: autoFocus, onClick: onClick, fragmentRef: fragmentRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const jqlDebuggerStoreActions = (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $512eM.useJqlDebuggerStoreActions)() : undefined;
    const [isAITourEnabled, { onDisableAITourUserPreference: onDisableAITourUserPreference, onEndAITour: onEndAITour }] = (0, $5Ys8c.useIsAITourEnabled)();
    const { onSetActiveCard: onSetActiveCard, onEndTour: onEndTour } = (0, $8QPci.useSpotlightCoordinationActions)();
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', $40fa2792d27558bd$var$analyticsEventName, {
            aiAction: 'aiAccessible'
        });
        onClick();
    }, [
        onClick
    ]);
    const handleTourClick = (0, $5uXOq.useCallback)((analyticsEvent, stop)=>{
        // Prevent any user actions before the JQL builder becomes interactive
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', $40fa2792d27558bd$var$analyticsEventName, {
            aiAction: 'aiAccessible',
            isSpotlightTourViewed: true
        });
        onDisableAITourUserPreference();
        onSetActiveCard((0, $761Hb.cardKeys).JQL_BUILDER_NL_TOGGLE, stop);
    }, [
        onSetActiveCard,
        onDisableAITourUserPreference
    ]);
    const renderSpotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qLuSt.default), {
        cardKey: (0, $761Hb.cardKeys).JQL_BUILDER_NL_TOGGLE,
        actions: [
            {
                onClick: ()=>{
                    onSetActiveCard((0, $761Hb.cardKeys).JQL_BUILDER_NL_TO_JQL);
                    onClick();
                },
                text: formatMessage((0, $jfJ6h.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>{
                    // End the tour in AI tour store
                    onEndAITour();
                    // End the tour in NIN changeboarding store
                    onEndTour();
                    onDisableAITourUserPreference();
                },
                text: formatMessage((0, $jfJ6h.default).close)
            }
        ],
        heading: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $jfJ6h.default).tourHeadingIssueTerminologyRefreshM4 : (0, $jfJ6h.default).tourHeading),
        target: "jql-builder-with-ai.natural-language-toggle",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        testId: "jql-builder-with-ai.ui.natural-language-toggle.spotlight",
        messageId: "jql-builder-with-ai.ui.natural-language-toggle.spotlight-tour-card.jql-builder-with-ai.natural-language-toggle.spotlight",
        messageType: "transactional"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $jfJ6h.default).tourBodyIssueTerminologyRefreshM4 : (0, $jfJ6h.default).tourBody));
    const newNaturalLanguageToggleData = (0, $8Uumt.useFragment)((0, $4QEHp.default), fragmentRef);
    // Spotlight tour should be disabled when AI is not enabled for the org since we still show the AI button with the appropriate popup
    const aiState = $40fa2792d27558bd$var$deriveAiState(newNaturalLanguageToggleData ?? null);
    if ((0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) // JQL debugger inherits the AI enabled state from NL-to-JQL as that is the parent experience
    // i.e. At this stage the JQL debugger only exists in the context of NL-to-JQL in Issue Navigator
    jqlDebuggerStoreActions?.setIsAiEnabled(aiState.aiAvailable && aiState.aiEnabled);
    return isAITourEnabled && aiState.aiAvailable && aiState.aiEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jDmD.default), {
        name: "jql-builder-with-ai.natural-language-toggle",
        renderSpotlightCard: renderSpotlightCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDegt.AIButtonPopup), {
        aiState: aiState,
        autoFocus: autoFocus,
        onClick: (_, analyticsEvent)=>handleTourClick(analyticsEvent),
        analyticsSource: "jiraNaturalLanguageToJql",
        analyticsEventName: $40fa2792d27558bd$var$analyticsEventName
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDegt.AIButtonPopup), {
        autoFocus: autoFocus,
        onClick: handleClick,
        analyticsSource: "jiraNaturalLanguageToJql",
        aiState: aiState,
        analyticsEventName: $40fa2792d27558bd$var$analyticsEventName
    });
};

});
parcelRegister("4QEHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7aad9fb82a41c4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1944cc3d838e0bedffe687cdec79df24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d7aad9fb82a41c4a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "atlassianIntelligenceProductFeature"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "naturalLanguageToggle_jqlBuilderWithAi",
        "selections": [
            {
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "feature",
                                "variableName": "atlassianIntelligenceProductFeature"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "atlassianIntelligenceProductFeatureInput"
                    },
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "atlassianIntelligenceAction",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "isAccessible"
                            }
                        ],
                        "type": "JiraAccessAtlassianIntelligenceFeature"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "link"
                            }
                        ],
                        "type": "JiraEnableAtlassianIntelligenceDeepLink"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ 
                        ],
                        "type": "JiraContactOrgAdminToEnableAtlassianIntelligence"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$d7aad9fb82a41c4a$var$node.hash = "363dd572327018fb46f24a58e80b534f";
var $d7aad9fb82a41c4a$export$2e2bcd8739ae039 = $d7aad9fb82a41c4a$var$node;

});

parcelRegister("jDegt", function(module, exports) {

$parcel$export(module.exports, "AIButtonPopup", () => $c7f77f965853424e$export$2d1eafbc659cd4ac);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $bvUB1 = parcelRequire("bvUB1");

var $4R6GH = parcelRequire("4R6GH");

var $jgJNO = parcelRequire("jgJNO");

var $4UN9Z = parcelRequire("4UN9Z");

var $6s1PB = parcelRequire("6s1PB");

var $kSkEp = parcelRequire("kSkEp");

var $IqmEJ = parcelRequire("IqmEJ");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $4J0Lr = parcelRequire("4J0Lr");

var $5C4yv = parcelRequire("5C4yv");
const $c7f77f965853424e$var$AIPopupContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $c7f77f965853424e$export$2d1eafbc659cd4ac = ({ onClick: onClick, autoFocus: autoFocus, analyticsSource: analyticsSource, aiState: aiState, analyticsEventName: analyticsEventName })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!aiState.aiAvailable) return null;
    if (aiState.aiEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4J0Lr.AIButton), {
        onClick: onClick,
        autoFocus: autoFocus
    });
    const { isOrgAdmin: isOrgAdmin, orgAdminLink: orgAdminLink } = aiState;
    const aiModalState = isOrgAdmin ? 'adminOptIn' : 'endUserOptIn';
    const getFormattedMessage = (messageObj)=>formatMessage(messageObj, {
            learn_more_link: (message)=>(0, $4R6GH.fg)('replace-anchor-with-link__gravity-ai') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                    target: "_blank",
                    onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atassianIntelligenceLearnMore', {
                            aiAction: aiModalState
                        }),
                    href: (0, $a56b51abbcbea207$export$af6d68522cb370b8)
                }, message) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    target: "_blank",
                    onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atassianIntelligenceLearnMore', {
                            aiAction: aiModalState
                        }),
                    href: (0, $a56b51abbcbea207$export$af6d68522cb370b8)
                }, message),
            // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
            p: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, message),
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
        });
    const handleEvent = (e)=>{
        const payload = e.payload || {};
        const payloadData = payload.data || {};
        // Pipe sendUIEvent type events as UI analytics
        if (payload.type === 'sendUIEvent' && payloadData.action && payloadData.actionSubject && payloadData.actionSubjectId) (0, $8zOmE.fireUIAnalytics)(e, `${payloadData.actionSubject} ${payloadData.action}`, payloadData.actionSubjectId);
        // Pipe sendScreenEvent type events as screen analytics
        if (payload.type === 'sendScreenEvent') (0, $8zOmE.fireScreenAnalytics)(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "atlassian-intelligence.common.ui.ai-button-popup.popup.ai-opt-in",
        messageType: "marketing",
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        popupComponent: $c7f77f965853424e$var$AIPopupContainerComponent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceName: `${analyticsSource}AiOptInDialog`,
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
                attributes: {
                    isOrgAdmin: isOrgAdmin
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
                channel: "fabric-elements",
                onEvent: handleEvent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UN9Z.default), {
                source: analyticsSource,
                product: "jira",
                isOrgAdmin: isOrgAdmin,
                image: isOrgAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $IqmEJ.default), {
                    alt: formatMessage((0, $5C4yv.default).aiOptInAltMessage)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kSkEp.default), {
                    alt: formatMessage((0, $5C4yv.default).aiOptInAltMessage)
                }),
                testId: "atlassian-intelligence.common.ui.ai-button-popup.ai-opt-in",
                onAdminClose: ()=>setIsOpen(false),
                onAdminCTA: ()=>setIsOpen(false),
                adminCTAText: formatMessage((0, $5C4yv.default).adminButton),
                adminCloseCTAText: formatMessage((0, $5C4yv.default).dismissButton),
                adminLink: orgAdminLink || undefined,
                headerText: formatMessage((0, $5C4yv.default).heading),
                adminHeaderText: formatMessage((0, $5C4yv.default).heading),
                bodyText: getFormattedMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5C4yv.default).userDescriptionIssueTermRefresh : (0, $5C4yv.default).userDescription),
                adminBodyText: getFormattedMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5C4yv.default).adminDescriptionIssueTermRefresh : (0, $5C4yv.default).adminDescription)
            }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4J0Lr.AIButton), {
                ...triggerProps,
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', analyticsEventName, {
                        aiAction: aiModalState
                    });
                    setIsOpen((open)=>!open);
                },
                autoFocus: autoFocus
            }),
        placement: "bottom-start"
    });
};

});
parcelRegister("4UN9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $498daaeb8cd4c6ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1mySm = parcelRequire("1mySm");


var $ek69Y = parcelRequire("ek69Y");

var $lJhAv = parcelRequire("lJhAv");
const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $VSDnB.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $ek69Y.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($1mySm)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1mySm))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $ek69Y.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;

});
parcelRegister("1mySm", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("ek69Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fe19a2c65ae0a6d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("lJhAv", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $1bcec8f5b168d85d$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $1bcec8f5b168d85d$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $1bcec8f5b168d85d$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $1bcec8f5b168d85d$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $1bcec8f5b168d85d$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1bcec8f5b168d85d$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kSkEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3775d4f3c2f4d4a$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $dKI7U = parcelRequire("dKI7U");
const $c3775d4f3c2f4d4a$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($dKI7U)));
const $c3775d4f3c2f4d4a$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($dKI7U)));
const $c3775d4f3c2f4d4a$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: $c3775d4f3c2f4d4a$export$abdf1e325e38b834,
    srcDark: $c3775d4f3c2f4d4a$export$87ec2877821a8f12
});
var $c3775d4f3c2f4d4a$export$2e2bcd8739ae039 = $c3775d4f3c2f4d4a$var$Illustration;
// for advanced use only
const $c3775d4f3c2f4d4a$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("dKI7U", function(module, exports) {
module.exports = new URL("ai-enable-banner-end-user.a7576f2c.svg", import.meta.url).toString();

});


parcelRegister("IqmEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89566e5130deb34d$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $1GUnx = parcelRequire("1GUnx");
const $89566e5130deb34d$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($1GUnx)));
const $89566e5130deb34d$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($1GUnx)));
const $89566e5130deb34d$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: $89566e5130deb34d$export$abdf1e325e38b834,
    srcDark: $89566e5130deb34d$export$87ec2877821a8f12
});
var $89566e5130deb34d$export$2e2bcd8739ae039 = $89566e5130deb34d$var$Illustration;
// for advanced use only
const $89566e5130deb34d$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("1GUnx", function(module, exports) {
module.exports = new URL("ai-enable-banner-org-admin.1ceaac44.svg", import.meta.url).toString();

});


parcelRegister("5C4yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f082fd398a73497$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7f082fd398a73497$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "atlassian-intelligence.common.ai-button-popup.heading",
        "defaultMessage": "Speed up your search"
    },
    adminDescription: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-description",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their issues faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>"
    },
    userDescription: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-description",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your issues faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>"
    },
    learnMore: {
        "id": "atlassian-intelligence.common.ai-button-popup.learn-more",
        "defaultMessage": "Learn more about Atlassian Intelligence"
    },
    dismissButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.dismiss-button",
        "defaultMessage": "Maybe later"
    },
    adminButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-button",
        "defaultMessage": "Get Started"
    },
    userButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-button",
        "defaultMessage": "Contact your Admin"
    },
    aiOptInAltMessage: {
        "id": "atlassian-intelligence.common.ai-button-popup.banner-alt",
        "defaultMessage": "Decorative pop up banner"
    },
    adminDescriptionIssueTermRefresh: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-description-issue-term-refresh",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their work faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>"
    },
    userDescriptionIssueTermRefresh: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-description-issue-term-refresh",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your work faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>"
    }
});

});


parcelRegister("jfJ6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76212e7b709881c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e76212e7b709881c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    close: {
        "id": "jql-builder-with-ai.natural-language-toggle.close",
        "defaultMessage": "Close"
    },
    next: {
        "id": "jql-builder-with-ai.natural-language-toggle.next",
        "defaultMessage": "Next"
    },
    tourHeading: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-heading",
        "defaultMessage": "Use AI to find issues faster"
    },
    tourBody: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-body",
        "defaultMessage": "Search for issues with Atlassian Intelligence instead of coming up with complex queries."
    },
    tourHeadingIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Use AI to find work items faster"
    },
    tourBodyIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-body-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items with Atlassian Intelligence instead of coming up with complex queries."
    }
});

});


parcelRegister("dkjuA", function(module, exports) {

$parcel$export(module.exports, "SpotlightTourContainer", () => $8078995b9dd69812$export$1ea37624009cc192);

var $dX2Ue = parcelRequire("dX2Ue");

var $cmAP1 = parcelRequire("cmAP1");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $5Ys8c = parcelRequire("5Ys8c");
const $8078995b9dd69812$export$1ea37624009cc192 = ({ children: children, userPreferences: userPreferences })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const data = (0, $8Uumt.useFragment)((0, $cmAP1.default), userPreferences);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dX2Ue.default));
    // Disable the user preference when the tour starts so it's not shown on subsequent page loads
    const onDisableAITourUserPreference = (0, $5uXOq.useCallback)(()=>{
        commitMutation({
            variables: {
                cloudId: cloudId,
                isEnabled: false
            }
        });
    }, [
        cloudId,
        commitMutation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ys8c.Container), {
        isAITourUserPreferenceEnabled: !!data?.isNaturalLanguageSpotlightTourEnabled,
        onDisableAITourUserPreference: onDisableAITourUserPreference
    }, children);
};

});
parcelRegister("dX2Ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f8cc5ced4b645df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16c73ccf3982bca1cf2f614dba33dfe5>>
 * @relayHash 3d2c5ddeb85976376bf23644a86ec8aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0
const $9f8cc5ced4b645df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                }
                            ],
                            "concreteType": "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload",
                            "kind": "LinkedField",
                            "name": "setNaturalLanguageSpotlightTourEnabled",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0",
            "metadata": {},
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9f8cc5ced4b645df$var$node.hash = "3f359c84a909e0fee178266828c63fb5";
var $9f8cc5ced4b645df$export$2e2bcd8739ae039 = $9f8cc5ced4b645df$var$node;

});

parcelRegister("cmAP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb17cee6142f827$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c41a47c132c7af9affa124c2a948186c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9fb17cee6142f827$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlightTourContainer_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isNaturalLanguageSpotlightTourEnabled"
        }
    ],
    "type": "JiraUserPreferences"
};
$9fb17cee6142f827$var$node.hash = "c677e86a45a387c3d35af97d3ab14b64";
var $9fb17cee6142f827$export$2e2bcd8739ae039 = $9fb17cee6142f827$var$node;

});





//# sourceMappingURL=async-jql-builder-with-ai.2ae9a7ff.js.map
